(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("IncidentDashboardController", IncidentDashboardController);

    IncidentDashboardController.$inject = ['$timeout', '$rootScope', '$scope', '$document', 'getIncidentData', '$q'];

    function IncidentDashboardController($timeout, $rootScope, $scope, $document, getIncidentData, $q) {
        var vm = this;
        
        // Request cancellation management
        var pendingDataRequests = {
            incidents: null,
            status: null,
            sla: null,
            roles: null,
            gp: null,
            trend: null
        };
        
        // Debounce timer for filter changes
        var filterChangeDebounceTimer = null;
        
        // Flag to prevent watcher from loading when ng-change handlers already did
        var isLoadingViaHandler = false;
        vm.chartData = [];
        vm.businessAreaName = [];
        vm.operationalAreaName = [];
        vm.districtList = [];
        vm.blockList = [];
        vm.gpList = [];
        vm.stateList = [];
        vm.packageList = [];
        vm.selectedBusinessArea = null;
        vm.selectedOperationalAreaName = null;
        vm.selectedDistrict = null;
        vm.selectedBlock = null;
        vm.loadSLABreachData=loadSLABreachData;
        vm.selectedGP = null;
        vm.selectedState = null;
        vm.selectedPackage = null;
        vm.selectedAMCStatus = 'ALL'; // Default to ALL
        vm.selectedAlertType = 'ALL';
        vm.alertTypeFilterOptions = [
            { id: 'ALL', name: 'All' }
        ];
        vm.selectedOpenAlertType = 'ALL';
        vm.openAlertTypeFilterOptions = [
            { id: 'ALL', name: 'All' }
        ];
        vm.amcStatusList = [
            { id: 'ALL', name: 'ALL' },
            { id: 'AMC', name: 'AMC' },
            { id: 'NONAMC', name: 'NON-AMC' }
        ];
        vm.lastFilterChanged = null; // Track which filter was changed last: 'package' or 'state'
        vm.fromDate = null;
        vm.toDate = null;
        vm.maxDate = new Date(); // Set max date to today to prevent future date selection
        vm.datePickerOptions = {
            maxDate: new Date() // Datepicker option to prevent future date selection
        };
        vm.dateRange = "";
        vm.showDatePopup = false;
        vm.datePickerOpenStatus = { fromDate: false, toDate: false };
        vm.dateValidationError = null; // Error message for date validation
        
        // Sorting variables for SLA Breach table
        vm.predicate = 'createdDate'; // Default sort field
        vm.reverse = false; // Default sort direction (ascending)
        
        // Sorting variables for Open Incidents table
        vm.openIncidentsPredicate = 'createdDate';
        vm.openIncidentsReverse = false;
        
        // Sorting variables for Resolved Incidents table
        vm.resolvedIncidentsPredicate = 'createdDate';
        vm.resolvedIncidentsReverse = false;
        
        // Sorting variables for Near To Breach table
        vm.nearToBreachPredicate = 'createdDate';
        vm.nearToBreachReverse = false;
        
        // Generic sort function for any table
        vm.sortTable = function(table, field) {
            var predKey, reverseKey, pageKey, transitionFunc;
            
            // Handle SLA Breach table (empty string means SLA table)
            if (!table || table === '') {
                predKey = 'predicate';
                reverseKey = 'reverse';
                pageKey = 'page';
                transitionFunc = vm.transition;
            } else {
                // Handle other tables
                predKey = table + 'Predicate';
                reverseKey = table + 'Reverse';
                pageKey = table + 'Page';
                var funcName = 'transition' + table.charAt(0).toUpperCase() + table.slice(1);
                transitionFunc = vm[funcName];
            }
            
            if (vm[predKey] === field) {
                vm[reverseKey] = !vm[reverseKey];
            } else {
                vm[predKey] = field;
                vm[reverseKey] = false;
            }
            
            // Update pagination for the specific table
            vm[pageKey] = 1;
            
            // Call the transition function with proper context
            if (typeof transitionFunc === 'function') {
                transitionFunc.call(vm);
            }
        };
        
        // Generic sort data function
        vm.applySorting = function(data, predicate, reverse) {
            if (!data || !Array.isArray(data) || data.length === 0) {
                return data || [];
            }
            if (!predicate) {
                return data;
            }
            
            var sorted = data.slice(); // Create a copy to avoid mutating original
            sorted.sort(function(a, b) {
                var aVal = a[predicate];
                var bVal = b[predicate];
                
                // Handle null/undefined values
                if (aVal == null && bVal == null) return 0;
                if (aVal == null) return reverse ? -1 : 1;
                if (bVal == null) return reverse ? 1 : -1;
                
                var compareResult = 0;
                
                // Handle Date objects
                if (aVal instanceof Date && bVal instanceof Date) {
                    compareResult = aVal.getTime() - bVal.getTime();
                } 
                // Handle strings
                else if (typeof aVal === 'string' && typeof bVal === 'string') {
                    var aStr = aVal.toLowerCase();
                    var bStr = bVal.toLowerCase();
                    compareResult = aStr < bStr ? -1 : (aStr > bStr ? 1 : 0);
                }
                // Handle numbers
                else if (typeof aVal === 'number' && typeof bVal === 'number') {
                    compareResult = aVal - bVal;
                }
                // Fallback to generic comparison
                else {
                    compareResult = aVal < bVal ? -1 : (aVal > bVal ? 1 : 0);
                }
                
                return reverse ? -compareResult : compareResult;
            });
            
            return sorted;
        };

        function normalizeAlertTypeName(value) {
            if (value === null || value === undefined) {
                return '-';
            }
            var normalized = String(value).trim();
            return normalized || '-';
        }

        function getFilteredSlaBreachesByAlertType(data) {
            var source = Array.isArray(data) ? data : [];
            if (!vm.selectedAlertType || vm.selectedAlertType === 'ALL') {
                return source;
            }
            return source.filter(function(item) {
                return normalizeAlertTypeName(item && item.caseTypeName) === vm.selectedAlertType;
            });
        }

        function getFilteredOpenIncidentsByAlertType(data) {
            var source = Array.isArray(data) ? data : [];
            if (!vm.selectedOpenAlertType || vm.selectedOpenAlertType === 'ALL') {
                return source;
            }
            return source.filter(function(item) {
                return normalizeAlertTypeName(item && item.caseTypeName) === vm.selectedOpenAlertType;
            });
        }

        function getFilteredMttrDetailsByAlertType(data) {
            var source = Array.isArray(data) ? data : [];
            if (!vm.selectedAlertType || vm.selectedAlertType === 'ALL') {
                return source;
            }
            return source.filter(function(item) {
                return normalizeAlertTypeName(item && item.caseTypeName) === vm.selectedAlertType;
            });
        }

        function updateAlertTypeFilterOptions(data) {
            var source = Array.isArray(data) ? data : [];
            var seen = {};
            var dynamicOptions = [];

            source.forEach(function(item) {
                var alertType = normalizeAlertTypeName(item && item.caseTypeName);
                if (alertType === '-' || seen[alertType]) {
                    return;
                }
                seen[alertType] = true;
                dynamicOptions.push({ id: alertType, name: alertType });
            });

            dynamicOptions.sort(function(a, b) {
                var aName = a.name.toLowerCase();
                var bName = b.name.toLowerCase();
                return aName < bName ? -1 : (aName > bName ? 1 : 0);
            });

            vm.alertTypeFilterOptions = [{ id: 'ALL', name: 'All' }].concat(dynamicOptions);

            if (!vm.selectedAlertType || !vm.alertTypeFilterOptions.some(function(option) {
                return option.id === vm.selectedAlertType;
            })) {
                vm.selectedAlertType = 'ALL';
            }
        }

        function updateOpenAlertTypeFilterOptions(data) {
            var source = Array.isArray(data) ? data : [];
            var seen = {};
            var dynamicOptions = [];

            source.forEach(function(item) {
                var alertType = normalizeAlertTypeName(item && item.caseTypeName);
                if (alertType === '-' || seen[alertType]) {
                    return;
                }
                seen[alertType] = true;
                dynamicOptions.push({ id: alertType, name: alertType });
            });

            dynamicOptions.sort(function(a, b) {
                var aName = a.name.toLowerCase();
                var bName = b.name.toLowerCase();
                return aName < bName ? -1 : (aName > bName ? 1 : 0);
            });

            vm.openAlertTypeFilterOptions = [{ id: 'ALL', name: 'All' }].concat(dynamicOptions);

            if (!vm.selectedOpenAlertType || !vm.openAlertTypeFilterOptions.some(function(option) {
                return option.id === vm.selectedOpenAlertType;
            })) {
                vm.selectedOpenAlertType = 'ALL';
            }
        }

        vm.onAlertTypeChange = function () {
            vm.page = 1;
            vm.updatePagedSLA();
        };

        vm.onOpenAlertTypeChange = function () {
            vm.openIncidentsPage = 1;
            vm.updatePagedOpenIncidents();
        };

        vm.hasFilteredSlaBreachData = function() {
            return getFilteredSlaBreachesByAlertType(vm.slaBreaches).length > 0;
        };

        vm.hasFilteredOpenIncidentsData = function() {
            return getFilteredOpenIncidentsByAlertType(vm.openIncidents).length > 0;
        };

        vm.hasFilteredMttrDetailsData = function() {
            return getFilteredMttrDetailsByAlertType(vm.mttrDetails).length > 0;
        };
        
        vm.openCalendar = function(field) { vm.datePickerOpenStatus[field] = true; };

        vm.onDatePickerClosed = function(field, args) {
            if (!args || !args.closeDate) {
                return;
            }

            vm[field] = args.closeDate;

            if (field === 'fromDate') {
                vm.calculateFromDate();
            } else if (field === 'toDate') {
                vm.calculateToDate();
            }
        };
        
        vm.calculateFromDate = function() {
            if (!vm.fromDate) {
                return; // User is still selecting date
            }
            
            // If only fromDate is set, clear any existing error
            if (!vm.toDate) {
                vm.dateValidationError = null;
                return;
            }
            
            // Both dates are set, validate
            var fromTime = new Date(vm.fromDate).getTime();
            var toTime = new Date(vm.toDate).getTime();
            
            if (fromTime > toTime) {
                vm.dateValidationError = 'From Date cannot be greater than To Date';
            } else {
                vm.dateValidationError = null; // Clear error if dates are now valid
                vm.dateRange = formatDate(vm.fromDate) + " - " + formatDate(vm.toDate);
            }
        };
        
        vm.calculateToDate = function() {
            if (!vm.toDate) {
                return; // User is still selecting date
            }
            
            // If only toDate is set, clear any existing error
            if (!vm.fromDate) {
                vm.dateValidationError = null;
                return;
            }
            
            // Both dates are set, validate
            var fromTime = new Date(vm.fromDate).getTime();
            var toTime = new Date(vm.toDate).getTime();
            
            if (toTime < fromTime) {
                vm.dateValidationError = 'To Date cannot be earlier than From Date';
            } else {
                vm.dateValidationError = null; // Clear error if dates are now valid
                vm.dateRange = formatDate(vm.fromDate) + " - " + formatDate(vm.toDate);
            }
        };

        // Watch for when date pickers close to trigger validation
        $scope.$watch(function() {
            return vm.datePickerOpenStatus.fromDate;
        }, function(newVal, oldVal) {
            if (oldVal === true && newVal === false) {
                // From date picker just closed - wait for model to update
                $timeout(function() {
                    if (vm.fromDate && vm.toDate) {
                        vm.calculateFromDate();
                        vm.calculateToDate();
                    }
                }, 300);
            }
        });

        $scope.$watch(function() {
            return vm.datePickerOpenStatus.toDate;
        }, function(newVal, oldVal) {
            if (oldVal === true && newVal === false) {
                // To date picker just closed - wait for model to update
                $timeout(function() {
                    if (vm.fromDate && vm.toDate) {
                        vm.calculateToDate();
                        vm.calculateFromDate();
                    }
                }, 300);
            }
        });

        vm.slaBreaches = [];
        vm.slaBreachCount = 0;
        vm.nearToBreachCount = 0;
        vm.noActionCount = 0;
        vm.gpDownCount = 0;
        vm.totalGPCount = 0;
        vm.blockDownCount = 0;
        vm.totalBlockCount = 0;
        vm.slaCompliancePerc = 0;
        vm.avgResolutionTime = 0;
        vm.avgResolutionHours = 0;
        vm.avgResponseTime = 0;
        vm.avgResponseHours = 0;
        vm.patrollerCount = 0;
        vm.frtCount = 0;
        vm.dayWiseTrendData = null;
        vm.priorityTotals = {
            ASSIGNED: 0,
            TOBEASSIGNED: 0,
            RESOLVED: 0,
            INPROGRESS: 0,
            PENDING: 0,
            CLOSED: 0
        };
        vm.resolvedwithinTimeCount = 0;

        // Open Incidents data
        vm.openIncidents = [];
        vm.showOpenIncidentsTable = false;
        vm.openIncidentsPage = 1;
        vm.openIncidentsTotalItems = 0;
        vm.openIncidentsQueryCount = 0;
        vm.openIncidentsPaged = [];
        
        // Resolved Incidents data
        vm.resolvedIncidents = [];
        vm.showResolvedIncidentsTable = false;
        vm.resolvedIncidentsPage = 1;
        vm.resolvedIncidentsTotalItems = 0;
        vm.resolvedIncidentsQueryCount = 0;
        vm.resolvedIncidentsPaged = [];
        
        // Near To Breach Incidents data
        vm.nearToBreachIncidents = [];
        vm.showNearToBreachTable = false;
        vm.nearToBreachPage = 1;
        vm.nearToBreachTotalItems = 0;
        vm.nearToBreachQueryCount = 0;
        vm.nearToBreachPaged = [];
        
        // Patroller data
        vm.patrollerUsers = [];
        vm.showPatrollerTable = false;
        vm.patrollerPage = 1;
        vm.patrollerTotalItems = 0;
        vm.patrollerQueryCount = 0;
        vm.patrollerPaged = [];
        
        // FRT data
        vm.frtUsers = [];
        vm.showFrtTable = false;
        vm.frtPage = 1;
        vm.frtTotalItems = 0;
        vm.frtQueryCount = 0;
        vm.frtPaged = [];

        // GP Down data
        vm.gpDownList = [];
        vm.showGpDownTable = false;
        vm.gpDownPage = 1;
        vm.gpDownTotalItems = 0;
        vm.gpDownQueryCount = 0;
        vm.gpDownPaged = [];
        vm.gpDownPredicate = 'caseCreatedTime';
        vm.gpDownReverse = true;

        // Block Down data
        vm.blockDownList = [];
        vm.showBlockDownTable = false;
        vm.blockDownPage = 1;
        vm.blockDownTotalItems = 0;
        vm.blockDownQueryCount = 0;
        vm.blockDownPaged = [];
        vm.blockDownPredicate = 'createdDate';
        vm.blockDownReverse = true;

        // MTTR Details data (shared by Resolved Incidents, SLA Compliance, AVG Resolution cards)
        vm.mttrDetails = [];
        vm.showMttrDetailsTable = false;
        vm.mttrDetailsPage = 1;
        vm.mttrDetailsTotalItems = 0;
        vm.mttrDetailsQueryCount = 0;
        vm.mttrDetailsPaged = [];
        vm.mttrDetailsPredicate = 'createdDate';
        vm.mttrDetailsReverse = false;

        vm.formatGpDownDuration = function(createdTime) {
            if (!createdTime) {
                return '-';
            }
            var createdMs = new Date(createdTime).getTime();
            if (isNaN(createdMs)) {
                return '-';
            }
            var diffMs = Date.now() - createdMs;
            if (diffMs < 0) {
                diffMs = 0;
            }
            var totalMinutes = Math.floor(diffMs / (1000 * 60));
            var hours = Math.floor(totalMinutes / 60);
            var minutes = totalMinutes % 60;
            return hours + 'h ' + minutes + 'm';
        };

        vm.getGpDownDurationStyle = function(createdTime) {
            var createdMs = new Date(createdTime).getTime();
            if (!createdTime || isNaN(createdMs)) {
                return {
                    'color': '#6c757d',
                    'font-weight': '400',
                    'font-size': 'inherit'
                };
            }

            var totalMinutes = Math.max(0, Math.floor((Date.now() - createdMs) / (1000 * 60)));
            var color = '#28a745';

            if (totalMinutes >= 480) {
                color = '#dc3545';
            } else if (totalMinutes >= 120) {
                color = '#e67e22';
            }

            return {
                'color': color,
                'font-weight': '400',
                'font-size': 'inherit'
            };
        };
        
        vm.toggleOpenIncidentsTable = function() {
            vm.showOpenIncidentsTable = !vm.showOpenIncidentsTable;
            // Hide all other tables when opening Open Incidents
            if (vm.showOpenIncidentsTable) {
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }
            if (vm.showOpenIncidentsTable && (!vm.openIncidents || vm.openIncidents.length === 0)) {
                vm.loadOpenIncidentsData();
            }
            
            // Scroll to the Open Incidents table when showing it
            if (vm.showOpenIncidentsTable) {
                $timeout(function() {
                    var element = document.getElementById('openIncidentsTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };
        
        vm.transitionOpenIncidents = function() {
            vm.updatePagedOpenIncidents();
        };
        
        vm.updatePagedOpenIncidents = function() {
            try {
                updateOpenAlertTypeFilterOptions(vm.openIncidents);
                var filteredData = getFilteredOpenIncidentsByAlertType(vm.openIncidents);
                var sortedData = vm.applySorting(filteredData, vm.openIncidentsPredicate, vm.openIncidentsReverse);
                vm.openIncidentsTotalItems = filteredData.length;
                vm.openIncidentsQueryCount = vm.openIncidentsTotalItems;

                var totalPages = Math.max(1, Math.ceil(vm.openIncidentsTotalItems / vm.itemsPerPage));
                if (vm.openIncidentsPage > totalPages) {
                    vm.openIncidentsPage = 1;
                }

                var start = (vm.openIncidentsPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.openIncidentsPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.openIncidentsPaged = vm.openIncidents || [];
            }
        };

        vm.toggleResolvedIncidentsTable = function() {
            vm.showResolvedIncidentsTable = !vm.showResolvedIncidentsTable;
            // Hide all other tables when opening Resolved Incidents
            if (vm.showResolvedIncidentsTable) {
                vm.showOpenIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }
            
            // Scroll to the Resolved Incidents table when showing it
            if (vm.showResolvedIncidentsTable) {
                $timeout(function() {
                    var element = document.getElementById('resolvedIncidentsTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };
        
        vm.transitionResolvedIncidents = function() {
            vm.updatePagedResolvedIncidents();
        };
        
        vm.updatePagedResolvedIncidents = function() {
            try {
                var sortedData = vm.applySorting(vm.resolvedIncidents, vm.resolvedIncidentsPredicate, vm.resolvedIncidentsReverse);
                var start = (vm.resolvedIncidentsPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.resolvedIncidentsPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.resolvedIncidentsPaged = vm.resolvedIncidents || [];
            }
        };

        vm.toggleNearToBreachTable = function() {
            vm.showNearToBreachTable = !vm.showNearToBreachTable;
            // Hide all other tables when opening Near To Breach
            if (vm.showNearToBreachTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }
            
            // Scroll to the Near To Breach table when showing it
            if (vm.showNearToBreachTable) {
                $timeout(function() {
                    var element = document.getElementById('nearToBreachTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };
        
        vm.transitionNearToBreach = function() {
            vm.updatePagedNearToBreach();
        };
        
        vm.updatePagedNearToBreach = function() {
            try {
                var sortedData = vm.applySorting(vm.nearToBreachIncidents, vm.nearToBreachPredicate, vm.nearToBreachReverse);
                var start = (vm.nearToBreachPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.nearToBreachPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.nearToBreachPaged = vm.nearToBreachIncidents || [];
            }
        };

        vm.togglePatrollerTable = function() {
            vm.showPatrollerTable = !vm.showPatrollerTable;
            // Hide all other tables when opening Patroller
            if (vm.showPatrollerTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }
            
            // Scroll to the Patroller table when showing it
            if (vm.showPatrollerTable) {
                $timeout(function() {
                    var element = document.getElementById('patrollerTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };
        
        vm.transitionPatroller = function() {
            vm.updatePagedPatroller();
        };
        
        vm.updatePagedPatroller = function() {
            try {
                var start = (vm.patrollerPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.patrollerPaged = (vm.patrollerUsers || []).slice(start, end);
            } catch (e) {
                vm.patrollerPaged = vm.patrollerUsers || [];
            }
        };
        vm.toggleFrtTable = function() {
            vm.showFrtTable = !vm.showFrtTable;
            // Hide all other tables when opening FRT
            if (vm.showFrtTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }
            
            // Scroll to the FRT table when showing it
            if (vm.showFrtTable) {
                $timeout(function() {
                    var element = document.getElementById('frtTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };
        
        vm.transitionFrt = function() {
            vm.updatePagedFrt();
        };
        
        vm.updatePagedFrt = function() {
            try {
                var start = (vm.frtPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.frtPaged = (vm.frtUsers || []).slice(start, end);
            } catch (e) {
                vm.frtPaged = vm.frtUsers || [];
            }
        };

        vm.toggleGpDownTable = function() {
            vm.showGpDownTable = !vm.showGpDownTable;
            // Hide all other tables when opening GP Down
            if (vm.showGpDownTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }

            // Scroll to the GP Down table when showing it
            if (vm.showGpDownTable) {
                $timeout(function() {
                    var element = document.getElementById('gpDownTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };

        vm.transitionGpDown = function() {
            vm.updatePagedGpDown();
        };

        vm.updatePagedGpDown = function() {
            try {
                var sortedData = vm.applySorting(vm.gpDownList, vm.gpDownPredicate, vm.gpDownReverse);
                var start = (vm.gpDownPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.gpDownPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.gpDownPaged = vm.gpDownList || [];
            }
        };

        vm.toggleBlockDownTable = function() {
            vm.showBlockDownTable = !vm.showBlockDownTable;
            // Hide all other tables when opening Block Down
            if (vm.showBlockDownTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showMttrDetailsTable = false;
            }

            if (vm.showBlockDownTable) {
                $timeout(function() {
                    var element = document.getElementById('blockDownTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };

        vm.transitionBlockDown = function() {
            vm.updatePagedBlockDown();
        };

        vm.updatePagedBlockDown = function() {
            try {
                var sortedData = vm.applySorting(vm.blockDownList, vm.blockDownPredicate, vm.blockDownReverse);
                var start = (vm.blockDownPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.blockDownPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.blockDownPaged = vm.blockDownList || [];
            }
        };

        vm.toggleMttrDetailsTable = function() {
            vm.showMttrDetailsTable = !vm.showMttrDetailsTable;
            // Hide all other tables when opening MTTR Details
            if (vm.showMttrDetailsTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
            }

            // Scroll to the MTTR Details table when showing it
            if (vm.showMttrDetailsTable) {
                $timeout(function() {
                    var element = document.getElementById('mttrDetailsTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };

        vm.openMttrDetailsTable = function() {
            vm.showMttrDetailsTable = true;
            vm.showOpenIncidentsTable = false;
            vm.showResolvedIncidentsTable = false;
            vm.showNearToBreachTable = false;
            vm.showPatrollerTable = false;
            vm.showFrtTable = false;
            vm.showGpDownTable = false;

            $timeout(function() {
                var element = document.getElementById('mttrDetailsTableSection');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 300);
        };

        vm.transitionMttrDetails = function() {
            vm.updatePagedMttrDetails();
        };

        vm.updatePagedMttrDetails = function() {
            try {
                updateAlertTypeFilterOptions(vm.mttrDetails);
                var filteredData = getFilteredMttrDetailsByAlertType(vm.mttrDetails);
                var sortedData = vm.applySorting(filteredData, vm.mttrDetailsPredicate, vm.mttrDetailsReverse);
                vm.mttrDetailsTotalItems = filteredData.length;
                vm.mttrDetailsQueryCount = vm.mttrDetailsTotalItems;

                var totalPages = Math.max(1, Math.ceil(vm.mttrDetailsTotalItems / vm.itemsPerPage));
                if (vm.mttrDetailsPage > totalPages) {
                    vm.mttrDetailsPage = 1;
                }

                var start = (vm.mttrDetailsPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.mttrDetailsPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.mttrDetailsPaged = vm.mttrDetails || [];
            }
        }

        // CSV Export Functions
        function formatDateForCSV(date) {
            if (!date) return '';
            var d = new Date(date);
            var day = String(d.getDate()).padStart(2, '0');
            var month = String(d.getMonth() + 1).padStart(2, '0');
            var year = d.getFullYear();
            var hours = String(d.getHours()).padStart(2, '0');
            var minutes = String(d.getMinutes()).padStart(2, '0');
            var seconds = String(d.getSeconds()).padStart(2, '0');
            return day + '-' + month + '-' + year + ' ' + hours + ':' + minutes + ':' + seconds;
        }

        function convertToCSV(data, headers, headerMap) {
            if (!data || data.length === 0) {
                return '';
            }

            // Create CSV header row
            var csvContent = headers.map(function(header) {
                var displayName = headerMap && headerMap[header] ? headerMap[header] : header;
                return '"' + (displayName || '').toString().replace(/"/g, '""') + '"';
            }).join(',') + '\n';

            // Create CSV data rows
            csvContent += data.map(function(row) {
                return headers.map(function(header) {
                    var value = row[header];
                    if (value === null || value === undefined) {
                        value = '';
                    } else if (header.toLowerCase().includes('date') && (value instanceof Date || typeof value === 'number')) {
                        // Handle Date objects or timestamps
                        value = formatDateForCSV(value);
                    } else if (header.toLowerCase().includes('date') && typeof value === 'string') {
                        // If it's a string date, try to parse and format it
                        var parsed = new Date(value);
                        if (!isNaN(parsed)) {
                            value = formatDateForCSV(parsed);
                        }
                    }
                    return '"' + value.toString().replace(/"/g, '""') + '"';
                }).join(',');
            }).join('\n');

            return csvContent;
        }

        function downloadCSV(csvContent, filename) {
            var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            var link = document.createElement('a');
            var url = URL.createObjectURL(blob);
            
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        function getConsolidatedIncidentDetailsForCSV() {
            var openIncidents = (vm.openIncidents || []).map(function(item) {
                return {
                    incidentCategory: 'Open',
                    createdDate: item.createdDate,
                    ticketId: item.ticketId,
                    description: item.description,
                    district: item.district,
                    block: item.block,
                    gpLocation: item.gpLocation,
                    baName: item.baName || '-',
                    oaName: item.oaName || '-',
                    caseTypeName: item.caseTypeName || '-',
                    caseStatus: item.caseStatus,
                    assignedTo: item.assignedTo,
                    rca: item.rca || '-',
                    type: item.type
                };
            });

            var resolvedIncidents = (vm.resolvedIncidents || []).map(function(item) {
                return {
                    incidentCategory: 'Resolved',
                    createdDate: item.createdDate,
                    ticketId: item.ticketId,
                    description: item.description,
                    district: item.district,
                    block: item.block,
                    gpLocation: item.gpLocation,
                    baName: item.baName || '-',
                    oaName: item.oaName || '-',
                    caseTypeName: item.caseTypeName || '-',
                    caseStatus: item.caseStatus,
                    assignedTo: item.assignedTo,
                    rca: item.rca || '-',
                    type: item.type
                };
            });

            return openIncidents.concat(resolvedIncidents);
        }

        vm.exportSLABreachCSV = function() {
            var data = vm.slaBreaches || [];
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'slaDue', 'caseStatus', 'assignedTo', 'gpStatus', 'slaStatus'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'slaDue': 'Breach/Remaining Time',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'gpStatus': 'GP Status',
                'slaStatus': 'SLA Status'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'SLA_Breach_' + timestamp + '.csv');
        };

        vm.exportFilteredSLABreachCSV = function() {
            var data = getFilteredSlaBreachesByAlertType(vm.slaBreaches || []);
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'slaDue', 'caseStatus', 'assignedTo', 'gpStatus', 'slaStatus'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'slaDue': 'Breach/Remaining Time',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'gpStatus': 'GP Status',
                'slaStatus': 'SLA Status'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'SLA_Breach_Filtered_' + timestamp + '.csv');
        };

        vm.exportOpenIncidentsCSV = function() {
            var data = vm.openIncidents || [];
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'caseStatus', 'assignedTo', 'rca', 'type'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'rca': 'RCA',
                'type': 'Priority'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Open_Incidents_' + timestamp + '.csv');
        };

        vm.exportFilteredOpenIncidentsCSV = function() {
            var data = getFilteredOpenIncidentsByAlertType(vm.openIncidents || []);
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'caseStatus', 'assignedTo', 'rca', 'type'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'rca': 'RCA',
                'type': 'Priority'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Open_Incidents_Filtered_' + timestamp + '.csv');
        };

        vm.exportOpenResolvedIncidentsCSV = function() {
            var data = getConsolidatedIncidentDetailsForCSV();
            var headers = ['incidentCategory', 'createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'caseStatus', 'assignedTo', 'rca', 'type'];
            var headerMap = {
                'incidentCategory': 'Incident Category',
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'rca': 'RCA',
                'type': 'Priority'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Open_And_Resolved_Incidents_' + timestamp + '.csv');
        };

        vm.exportResolvedIncidentsCSV = function() {
            var data = vm.resolvedIncidents || [];
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'caseStatus', 'assignedTo', 'rca', 'type'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'rca': 'RCA',
                'type': 'Priority'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Resolved_Incidents_' + timestamp + '.csv');
        };

        vm.exportNearToBreachCSV = function() {
            var data = vm.nearToBreachIncidents || [];
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'slaDue', 'caseStatus', 'assignedTo', 'gpStatus', 'slaStatus'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'slaDue': 'Breach/Remaining Time',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'gpStatus': 'GP Status',
                'slaStatus': 'SLA Status'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Near_Threshold_' + timestamp + '.csv');
        };

        vm.exportPatrollerCSV = function() {
            var data = vm.patrollerUsers || [];
            var headers = ['login', 'firstName', 'lastName', 'email', 'phone', 'reportingStatus', 'applicationVersion'];
            var csv = convertToCSV(data, headers);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Patroller_Team_' + timestamp + '.csv');
        };

        vm.exportFrtCSV = function() {
            var data = vm.frtUsers || [];
            var headers = ['login', 'firstName', 'lastName', 'email', 'phone', 'reportingStatus', 'applicationVersion'];
            var csv = convertToCSV(data, headers);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'FRT_' + timestamp + '.csv');
        };

        vm.exportGpDownCSV = function() {
            var data = (vm.gpDownList || []).map(function(item) {
                var createdDateObj = item.caseCreatedTime ? new Date(item.caseCreatedTime) : null;
                return {
                    createdAt: createdDateObj && !isNaN(createdDateObj.getTime())
                        ? String(createdDateObj.getDate()).padStart(2, '0') + '-' + String(createdDateObj.getMonth() + 1).padStart(2, '0') + '-' + createdDateObj.getFullYear() + ' ' +
                          String(createdDateObj.getHours()).padStart(2, '0') + ':' + String(createdDateObj.getMinutes()).padStart(2, '0') + ':' + String(createdDateObj.getSeconds()).padStart(2, '0')
                        : '',
                    ticketId: item.ticketId || item.caseNumber || '',
                    description: item.description || '',
                    assetName: item.assetName || '',
                    state: item.state || '',
                    district: item.district || '',
                    block: item.block || '',
                    'AMC/NON-AMC Status': item.amcStatus || '',
                    assignTo: item.assignTo || ''
                };
            });
            var headers = ['createdAt', 'ticketId', 'description', 'assetName', 'state', 'district', 'block', 'AMC/NON-AMC Status', 'assignTo'];
            var csv = convertToCSV(data, headers);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'GP_Down_List_' + timestamp + '.csv');
        };

        vm.exportBlockDownCSV = function() {
            var data = (vm.blockDownList || []).map(function(item) {
                var createdDateObj = item.createdDate ? new Date(item.createdDate) : null;
                var dueDateObj = item.dueDate ? new Date(item.dueDate) : null;
                return {
                    createdAt: createdDateObj && !isNaN(createdDateObj.getTime())
                        ? String(createdDateObj.getDate()).padStart(2, '0') + '-' + String(createdDateObj.getMonth() + 1).padStart(2, '0') + '-' + createdDateObj.getFullYear() + ' ' +
                          String(createdDateObj.getHours()).padStart(2, '0') + ':' + String(createdDateObj.getMinutes()).padStart(2, '0') + ':' + String(createdDateObj.getSeconds()).padStart(2, '0')
                        : '',
                    dueDate: dueDateObj && !isNaN(dueDateObj.getTime())
                        ? String(dueDateObj.getDate()).padStart(2, '0') + '-' + String(dueDateObj.getMonth() + 1).padStart(2, '0') + '-' + dueDateObj.getFullYear() + ' ' +
                          String(dueDateObj.getHours()).padStart(2, '0') + ':' + String(dueDateObj.getMinutes()).padStart(2, '0') + ':' + String(dueDateObj.getSeconds()).padStart(2, '0')
                        : '',
                    ticketId: item.ticketId || '',
                    description: item.description || '',
                    state: item.state || '',
                    district: item.district || '',
                    block: item.block || '',
                    priority: item.priority || '',
                    assignedTo: item.assignedTo || item.assignedToUser || '',
                    status: item.caseStatus || item.status || '',
                    caseTypeName: item.caseTypeName || ''
                };
            });
            var headers = ['createdAt', 'dueDate', 'ticketId', 'description', 'state', 'district', 'block', 'priority', 'assignedTo', 'status', 'caseTypeName'];
            var csv = convertToCSV(data, headers);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Block_Incidents_' + timestamp + '.csv');
        };

        vm.exportMttrDetailsCSV = function() {
            var data = vm.mttrDetails || [];
            var headers = ['createdDate', 'resolvedDate', 'resolutionTime', 'slaStatus', 'ticketId', 'title', 'district', 'block', 'gpLocation', 'incidentStatus', 'rca', 'state', 'priority', 'assignedTo'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'resolvedDate': 'Resolved date and time',
                'resolutionTime': 'Resolution Time',
                'slaStatus': 'SLA Status',
                'ticketId': 'Ticket ID',
                'title': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'incidentStatus': 'Incident Status',
                'rca': 'RCA',
                'state': 'State',
                'priority': 'Priority',
                'assignedTo': 'Assigned To'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'MTTR_Details_' + timestamp + '.csv');
        };

        vm.exportFilteredMttrDetailsCSV = function() {
            var data = getFilteredMttrDetailsByAlertType(vm.mttrDetails || []);
            var headers = ['createdDate', 'resolvedDate', 'resolutionTime', 'slaStatus', 'ticketId', 'title', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'incidentStatus', 'rca', 'state', 'priority', 'assignedTo'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'resolvedDate': 'Resolved date and time',
                'resolutionTime': 'Resolution Time',
                'slaStatus': 'SLA Status',
                'ticketId': 'Ticket ID',
                'title': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'incidentStatus': 'Incident Status',
                'rca': 'RCA',
                'state': 'State',
                'priority': 'Priority',
                'assignedTo': 'Assigned To'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'MTTR_Details_Filtered_' + timestamp + '.csv');
        };

        // Pagination for SLA table.
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.totalItems = 0;
        vm.queryCount = 0;
        vm.slaBreachesPaged = [];
        vm.transition = function () {
            vm.updatePagedSLA();
        };
        vm.updatePagedSLA = function () {
            try {
                updateAlertTypeFilterOptions(vm.slaBreaches);
                var filteredData = getFilteredSlaBreachesByAlertType(vm.slaBreaches);
                var sortedData = vm.applySorting(filteredData, vm.predicate, vm.reverse);
                vm.totalItems = filteredData.length;
                vm.queryCount = vm.totalItems;

                var totalPages = Math.max(1, Math.ceil(vm.totalItems / vm.itemsPerPage));
                if (vm.page > totalPages) {
                    vm.page = 1;
                }

                var start = (vm.page - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.slaBreachesPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.slaBreachesPaged = vm.slaBreaches || [];
            }
        };

        // Default last 7 days
        (function setLastSevenDays() {
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            start.setDate(start.getDate() - 6);
            vm.fromDate = start;
            vm.toDate = end;
            vm.dateRange = formatDate(vm.fromDate) + " - " + formatDate(vm.toDate);
        })();

        vm.donutCharts = [];
        vm.stateList = [];
        function loadPage() {
            // Load Packages from separate API
            getIncidentData.getPackages(function (response) {
                if (response.data && response.data.length > 0) {
                    vm.packageList = response.data.map(function(packageName, index) {
                        return {
                            id: packageName,
                            name: packageName
                        };
                    });
                    
                    // Set first package as default after packages are loaded
                    $timeout(function() {
                        if (vm.packageList && vm.packageList.length > 0) {
                            vm.selectedPackage = vm.packageList[0].id;
                            
                            // Load states for the default package
                            loadStatesForPackage(vm.selectedPackage);
                            
                            // Trigger data load with first package
                            $timeout(function() {
                                vm.onPackageChange(vm.selectedPackage);
                            }, 100);
                        }
                    }, 200);
                }
            });
            
            // Load SLA Breach data - but don't block if it fails
            try {
                vm.loadSLABreachData();
            } catch (e) {
                console.error('Error loading SLA breach data:', e);
            }
        }
        
        // Helper function to load states based on selected package
        function loadStatesForPackage(packageId) {
            if (!packageId) {
                vm.stateList = [];
                return;
            }
            
            getIncidentData.getStatesByPackage(packageId, function (response) {
                if (response.data && response.data.length > 0) {
                    vm.stateList = response.data.map(function(stateName, index) {
                        return {
                            id: stateName,
                            name: stateName
                        };
                    });
                } else {
                    vm.stateList = [];
                }
            });
        }
        loadPage();

        // Initialize Google Map
        var incidentMap = null;
        function initializeMap() {
            var centerGeofence = {
                lat: $rootScope.DEFAULT_LATITUDE || 28.7041,
                lng: $rootScope.DEFAULT_LONGITUDE || 77.1025
            };

            var mapElement = document.getElementById('incident-map');
            if (mapElement && typeof google !== 'undefined' && google.maps) {
                incidentMap = new google.maps.Map(mapElement, {
                    zoom: 5,
                    center: centerGeofence,
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    styles: [
                        {
                            featureType: 'poi',
                            elementType: 'labels.icon',
                            stylers: [{ color: '#63666A' }]
                        },
                        {
                            elementType: 'labels.text.fill',
                            stylers: [{ color: '#63666A' }]
                        }
                    ]
                });
            }
        }

        // Initialize map after a short delay to ensure DOM is ready
        $timeout(initializeMap, 500);

        // Close date popup when clicking outside
        (function setupClickOutsideClose() {
            var onDocClick = function (e) {
                try {
                    if (!vm.showDatePopup) { return; }
                    var popupEl = document.getElementById('incident-date-popup');
                    var triggerEl = document.getElementById('incident-date-range-input');
                    if (!popupEl) { return; }
                    if (popupEl.contains(e.target)) { return; }
                    if (triggerEl && triggerEl.contains(e.target)) { return; }
                    
                    // Check if click is on datepicker elements (which are rendered outside the popup)
                    var target = e.target;
                    if (target.closest('.uib-datepicker-popup') || 
                        target.closest('.dropdown-menu') ||
                        target.classList.contains('uib-day') ||
                        target.classList.contains('uib-daypicker') ||
                        target.classList.contains('btn-default')) {
                        return;
                    }
                    
                    $timeout(function () { vm.showDatePopup = false; });
                } catch (err) { /* noop */ }
            };
            $document.on('click', onDocClick);
            $scope.$on('$destroy', function () { $document.off('click', onDocClick); });
        })();

        // Helper function to remove seconds from time string
        function removeSeconds(timeStr) {
            if (!timeStr || timeStr === '-') {
                return timeStr;
            }
            // Remove seconds pattern like "17s" or "17 s"
            return timeStr.replace(/\s*\d+s\s*$/i, '').trim();
        }

        // Helper function to cancel pending HTTP requests
        function cancelPendingRequests() {
            // Cancel all pending requests to prevent race conditions
            for (var key in pendingDataRequests) {
                if (pendingDataRequests[key] && pendingDataRequests[key].resolve) {
                    pendingDataRequests[key].resolve('cancelled');
                    pendingDataRequests[key] = null;
                }
            }
        }

        // Debounce function for filter changes to prevent multiple simultaneous API calls
        function debounceFilterChange(callback, delay) {
            if (filterChangeDebounceTimer) {
                $timeout.cancel(filterChangeDebounceTimer);
            }
            filterChangeDebounceTimer = $timeout(function() {
                callback();
                filterChangeDebounceTimer = null;
            }, delay || 300);
        }

        // Wrapper to load SLA data with proper cancellation
        function loadSLADataWithCancellation() {
            // Cancel any pending SLA requests
            if (pendingDataRequests.sla) {
                $timeout.cancel(pendingDataRequests.sla);
            }
            loadSLABreachData();
        }

        // Helper function to abbreviate GP Status
        function abbreviateGPStatus(status) {
            if (!status || status === '-') {
                return status;
            }
            // Abbreviate UNKNOWN PREV DOWN to PREV DOWN
            if (status === 'UNKNOWN PREV DOWN') {
                return 'PREV DOWN';
            }
            return status;
        }

        // Function to load SLA Breach data from API
       function loadSLABreachData() {            
            try {
                // Get date range
                var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
                var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;
                
                // Check if package or state filter is selected - use different API
                // But only if GP, Block, District, OA, or BA are NOT selected
                if ((vm.selectedPackage || vm.selectedState) && 
                    !vm.selectedGP && !vm.selectedBlock && !vm.selectedDistrict && 
                    !vm.selectedOperationalAreaName && !vm.selectedBusinessArea) {
                    var packageId = vm.selectedPackage || '';
                    var stateId = vm.selectedState || '';
                    
                    // Determine type based on which filter was changed last
                    var type;
                    if (vm.lastFilterChanged === 'state') {
                        type = 'STATE'; // State was changed last
                    } else if (vm.lastFilterChanged === 'package') {
                        type = 'PACKAGE'; // Package was changed last
                    } else if (vm.selectedPackage) {
                        type = 'PACKAGE'; // Default to package if it's selected
                    } else if (vm.selectedState) {
                        type = 'STATE'; // Default to state if only state is selected
                    }
                    
                    // console.log('Loading SLA data by package/state - Package:', packageId, 'State:', stateId, 'Type:', type, 'LastChanged:', vm.lastFilterChanged);
                    
                    if (typeof getIncidentData.getSLAStatusDataByPackageAndState === 'function') {
                        getIncidentData.getSLAStatusDataByPackageAndState(
                            packageId,
                            stateId,
                            type, 
                            fromTS, 
                            toTS,
                            vm.selectedAMCStatus,
                            function(response) {
                                try {
                                    if (response && response.data) {
                                        vm.transformAndDisplaySLAData(response.data);
                                    } else if (response === null) {
                                        console.error('>>> API call failed - response is null (check service error)');
                                        vm.slaBreaches = [];
                                        vm.avgResolutionTime = 0;
                                        vm.avgResolutionHours = 0;
                                        vm.avgResponseTime = 0;
                                        vm.avgResponseHours = 0;
                                    } else {
                                        console.warn('>>> No data in SLA response:', response);
                                        vm.slaBreaches = [];
                                        vm.avgResolutionTime = 0;
                                        vm.avgResolutionHours = 0;
                                        vm.avgResponseTime = 0;
                                        vm.avgResponseHours = 0;
                                    }
                                } catch (e) {
                                    console.error('>>> Error transforming SLA data:', e);
                                    vm.slaBreaches = [];
                                    vm.avgResolutionTime = 0;
                                    vm.avgResolutionHours = 0;
                                    vm.avgResponseTime = 0;
                                    vm.avgResponseHours = 0;
                                }
                            }
                        );
                    } else {
                        console.error('>>> getSLAStatusDataByPackageAndState function not available on service!');
                    }
                    return;
                }
                
                // Build ID based on selected filters (original logic for BA/OA/District/Block/GP)
                var id;
                if (vm.selectedGP) {
                    id = vm.selectedGP;
                } else if (vm.selectedBlock) {
                    id = vm.selectedBlock;
                } else if (vm.selectedDistrict) {
                    id = vm.selectedDistrict;
                } else if (vm.selectedOperationalAreaName) {
                    id = vm.selectedOperationalAreaName;
                } else if (vm.selectedBusinessArea) {
                    id = vm.selectedBusinessArea;
                } else {
                    // No valid filter selected - don't make the API call
                    // console.log('No valid filter selected - skipping SLA breach data API call');
                    vm.slaBreaches = [];
                    vm.avgResolutionTime = 0;
                    vm.avgResolutionHours = 0;
                    vm.avgResponseTime = 0;
                    vm.avgResponseHours = 0;
                    return;
                }
                
                // Determine type based on filter level
                var type = 'BA'; // Default to Business Area
                if (vm.selectedGP) {
                    type = 'GP';
                } else if (vm.selectedBlock) {
                    type = 'MINI';
                } else if (vm.selectedDistrict) {
                    type = 'MASTER';
                } else if (vm.selectedOperationalAreaName) {
                    type = 'OA';
                }
                
                // console.log('Loading SLA data with ID:', id, 'Type:', type);
                                
                if (typeof getIncidentData.getSLAStatusData === 'function') {                    
                    getIncidentData.getSLAStatusData(id, type, fromTS, toTS, vm.selectedAMCStatus, function(response) {                        
                        try {
                            if (response && response.data) {
                                vm.transformAndDisplaySLAData(response.data);
                            } else if (response === null) {
                                console.error('>>> API call failed - response is null (check service error)');
                                vm.slaBreaches = [];
                                vm.avgResolutionTime = 0;
                                vm.avgResolutionHours = 0;
                                vm.avgResponseTime = 0;
                                vm.avgResponseHours = 0;
                            } else {
                                console.warn('>>> No data in SLA response:', response);
                                vm.slaBreaches = [];
                                vm.avgResolutionTime = 0;
                                vm.avgResolutionHours = 0;
                                vm.avgResponseTime = 0;
                                vm.avgResponseHours = 0;
                            }
                        } catch (e) {
                            console.error('>>> Error transforming SLA data:', e);
                            vm.slaBreaches = [];
                            vm.avgResolutionTime = 0;
                            vm.avgResolutionHours = 0;
                            vm.avgResponseTime = 0;
                            vm.avgResponseHours = 0;
                        }
                    });
                } else {
                    console.error('>>> getSLAStatusData function not available on service!');
                }
            } catch (e) {
                console.error('>>> Error in loadSLABreachData:', e);
            }
        };

        vm.loadRoleCounts = function() {
            try {
                var name = '';
                var type = '';
                
                // Check if package or state was last changed - they should take priority
                if (vm.lastFilterChanged === 'package' && vm.selectedPackage) {
                    name = vm.selectedPackage;
                    type = 'PACKAGE';
                } else if (vm.lastFilterChanged === 'state' && vm.selectedState) {
                    name = vm.selectedState;
                    type = 'STATE';
                }
                // Otherwise use hierarchical filter priority: GP > Block > District > OA > BA
                else if (vm.selectedGP) {
                    name = vm.selectedGP;
                    type = 'GP';
                } else if (vm.selectedBlock) {
                    name = vm.selectedBlock;
                    type = 'MINI';
                } else if (vm.selectedDistrict) {
                    name = vm.selectedDistrict;
                    type = 'MASTER';
                } else if (vm.selectedOperationalAreaName) {
                    name = vm.selectedOperationalAreaName;
                    type = 'OA';
                } else if (vm.selectedBusinessArea) {
                    name = vm.selectedBusinessArea;
                    type = 'BA';
                } else if (vm.selectedState) {
                    name = vm.selectedState;
                    type = 'STATE';
                } else if (vm.selectedPackage) {
                    name = vm.selectedPackage;
                    type = 'PACKAGE';
                } else {
                    // No filter selected, reset counts
                    vm.patrollerCount = 0;
                    vm.frtCount = 0;
                    return;
                }
                
                // console.log('Loading role counts for:', name, 'Type:', type);
                
                if (typeof getIncidentData.getRoleCountsByAuthority === 'function') {
                    getIncidentData.getRoleCountsByAuthority(name, type, function(response) {
                        try {
                            // console.log('>>> getRoleCountsByAuthority response:', response);
                            if (response && response.data && Array.isArray(response.data)) {
                                vm.patrollerCount = 0;
                                vm.frtCount = 0;
                                vm.patrollerUsers = [];
                                vm.frtUsers = [];
                                
                                response.data.forEach(function(roleData) {
                                    if (roleData.role === 'ROLE_PATROLLER') {
                                        vm.patrollerCount = roleData.count || 0;
                                        vm.patrollerCurrentDayCheckInCount = roleData.currentdayCheckInCount || 0;
                                        // Extract user data for patroller table
                                        if (roleData.userData && Array.isArray(roleData.userData)) {
                                            vm.patrollerUsers = roleData.userData.map(function(user) {
                                                return {
                                                    login: user.login || '-',
                                                    id: user.id || '-',
                                                    firstName: user.firstName || '-',
                                                    lastName: user.lastName || '-',
                                                    email: user.email || '-',
                                                    phone: user.phone || '-',
                                                    gpsStatus: user.gpsStatus ? 'Active' : 'Inactive',
                                                    reportingStatus: user.reportingStatus ? 'Reporting' : 'Not Reporting',
                                                    operatingSystem: user.operatingSystem || '-',
                                                    applicationVersion: user.applicationVersion 
                                                };
                                            });
                                        }
                                    } else if (roleData.role === 'ROLE_FRT') {
                                        vm.frtCount = roleData.count || 0;
                                        vm.frtCurrentDayCheckInCount = roleData.currentdayCheckInCount || 0;
                                        // Extract user data for FRT table
                                        if (roleData.userData && Array.isArray(roleData.userData)) {
                                            vm.frtUsers = roleData.userData.map(function(user) {
                                                return {
                                                    login: user.login || '-',
                                                    id: user.id || '-',
                                                    firstName: user.firstName || '-',
                                                    lastName: user.lastName || '-',
                                                    email: user.email || '-',
                                                    phone: user.phone || '-',
                                                    gpsStatus: user.gpsStatus ? 'Active' : 'Inactive',
                                                    reportingStatus: user.reportingStatus ? 'Reporting' : 'Not Reporting',
                                                    operatingSystem: user.operatingSystem || '-',
                                                    applicationVersion: user.applicationVersion 
                                                };
                                            });
                                        }
                                    }
                                });
                                
                                // Update patroller pagination
                                vm.patrollerTotalItems = (vm.patrollerUsers || []).length;
                                vm.patrollerQueryCount = vm.patrollerTotalItems;
                                vm.patrollerPage = 1;
                                vm.updatePagedPatroller();
                                
                                // Update FRT pagination
                                vm.frtTotalItems = (vm.frtUsers || []).length;
                                vm.frtQueryCount = vm.frtTotalItems;
                                vm.frtPage = 1;
                                vm.updatePagedFrt();
                                
                                // console.log('Role counts - Patroller:', vm.patrollerCount, 'FRT:', vm.frtCount);
                            } else {
                                console.warn('No role count data in response:', response);
                                vm.patrollerCount = 0;
                                vm.frtCount = 0;
                                vm.patrollerUsers = [];
                                vm.frtUsers = [];
                            }
                        } catch (e) {
                            console.error('Error processing role counts:', e);
                            vm.patrollerCount = 0;
                            vm.frtCount = 0;
                            vm.patrollerUsers = [];
                            vm.frtUsers = [];
                        }
                    });
                } else {
                    console.error('getRoleCountsByAuthority function not available on service!');
                }
            } catch (e) {
                console.error('Error in loadRoleCounts:', e);
            }
        };

        vm.loadGPTotalCount = function() {
            try {
                var id = '';
                var type = '';
                
                // Check if package or state was last changed - they should take priority
                if (vm.lastFilterChanged === 'package' && vm.selectedPackage) {
                    id = vm.selectedPackage;
                    type = 'PACKAGE';
                } else if (vm.lastFilterChanged === 'state' && vm.selectedState) {
                    id = vm.selectedState;
                    type = 'STATE';
                }
                // Otherwise use hierarchical filter priority: GP > Block > District > OA > BA
                else if (vm.selectedGP) {
                    id = vm.selectedGP;
                    type = 'GP';
                } else if (vm.selectedBlock) {
                    id = vm.selectedBlock;
                    type = 'MINI';
                } else if (vm.selectedDistrict) {
                    id = vm.selectedDistrict;
                    type = 'MASTER';
                } else if (vm.selectedOperationalAreaName) {
                    id = vm.selectedOperationalAreaName;
                    type = 'OA';
                } else if (vm.selectedBusinessArea) {
                    id = vm.selectedBusinessArea;
                    type = 'BA';
                } else if (vm.selectedState) {
                    id = vm.selectedState;
                    type = 'STATE';
                } else if (vm.selectedPackage) {
                    id = vm.selectedPackage;
                    type = 'PACKAGE';
                } else {
                    // No filter selected, reset count
                    vm.totalGPCount = 0;
                    return;
                }
                
                // console.log('Loading GP total count for ID:', id, 'Type:', type);
                
                if (typeof getIncidentData.getGPTotalCount === 'function') {
                    getIncidentData.getGPTotalCount(id, type, vm.selectedAMCStatus, function(response) {
                        try {
                            if (response && response.data !== undefined && response.data !== null) {
                                vm.totalGPCount = response.data;
                                // console.log('GP Total Count:', vm.totalGPCount);
                            } else {
                                console.warn('No GP total count data in response:', response);
                                vm.totalGPCount = 0;
                            }
                        } catch (e) {
                            console.error('Error processing GP total count:', e);
                            vm.totalGPCount = 0;
                        }
                    });
                } else {
                    console.error('getGPTotalCount function not available on service!');
                }
            } catch (e) {
                console.error('Error in loadGPTotalCount:', e);
            }
        };

        vm.loadDayWiseTrendData = function() {
            // console.log('=== loadDayWiseTrendData CALLED ===');
            try {
                var id = '';
                var type = '';
                
                // Check if package or state was last changed - they should take priority
                if (vm.lastFilterChanged === 'package' && vm.selectedPackage) {
                    id = vm.selectedPackage;
                    type = 'PACKAGE';
                } else if (vm.lastFilterChanged === 'state' && vm.selectedState) {
                    id = vm.selectedState;
                    type = 'STATE';
                }
                // Otherwise use hierarchical filter priority: GP > Block > District > OA > BA
                else if (vm.selectedGP) {
                    id = vm.selectedGP;
                    type = 'GP';
                } else if (vm.selectedBlock) {
                    id = vm.selectedBlock;
                    type = 'MINI';
                } else if (vm.selectedDistrict) {
                    id = vm.selectedDistrict;
                    type = 'MASTER';
                } else if (vm.selectedOperationalAreaName) {
                    id = vm.selectedOperationalAreaName;
                    type = 'OA';
                } else if (vm.selectedBusinessArea) {
                    id = vm.selectedBusinessArea;
                    type = 'BA';
                } else if (vm.selectedState) {
                    id = vm.selectedState;
                    type = 'STATE';
                } else if (vm.selectedPackage) {
                    id = vm.selectedPackage;
                    type = 'PACKAGE';
                } else {
                    // No filter selected, use default empty data
                    // console.log('No filter selected, rendering default chart');
                    renderOverallObservationChart();
                    return;
                }
                
                var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
                var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;
                
                // console.log('Loading day-wise trend data for ID:', id, 'Type:', type, 'FromDate:', fromTS, 'ToDate:', toTS);
                
                if (typeof getIncidentData.getDayWiseIncidentCounts === 'function') {
                    getIncidentData.getDayWiseIncidentCounts(id, fromTS, toTS, type, vm.selectedAMCStatus, function(response) {
                        try {
                            if (response && response.data) {
                                vm.dayWiseTrendData = response.data;
                                // console.log('Day-wise trend data:', vm.dayWiseTrendData);
                                renderOverallObservationChart();
                            } else {
                                console.warn('No day-wise trend data in response:', response);
                                vm.dayWiseTrendData = null;
                                renderOverallObservationChart();
                            }
                        } catch (e) {
                            console.error('Error processing day-wise trend data:', e);
                            vm.dayWiseTrendData = null;
                            renderOverallObservationChart();
                        }
                    });
                } else {
                    console.error('getDayWiseIncidentCounts function not available on service!');
                }
            } catch (e) {
                console.error('Error in loadDayWiseTrendData:', e);
            }
        };

        // Function to transform API response to table display format
        vm.transformAndDisplaySLAData = function(apiResponse) {
            try {
                // DEBUG: Log the entire API response to see what fields are available
                // console.log('=== SLA API Response ===', apiResponse);
                // console.log('Response keys:', apiResponse ? Object.keys(apiResponse) : 'null response');
                // console.log('Has openCaseData?', apiResponse && apiResponse.openCaseData);
                if (apiResponse && apiResponse.openCaseData) {
                    // console.log('openCaseData length:', apiResponse.openCaseData.length);
                    // console.log('First open case:', apiResponse.openCaseData[0]);
                }
                // console.log('Has resovedcaseData?', apiResponse && apiResponse.resovedcaseData);
                if (apiResponse && apiResponse.resovedcaseData) {
                    // console.log('resovedcaseData length:', apiResponse.resovedcaseData.length);
                    // console.log('First resolved case:', apiResponse.resovedcaseData[0]);
                }
                
                vm.slaBreaches = [];
                vm.slaBreachCount = 0;
                vm.nearToBreachCount = 0;
                vm.noActionCount = 0;
                vm.gpDownCount = 0;
                vm.blockDownCount = 0;
                vm.totalBlockCount = 0;
                // Note: totalGPCount is managed by loadGPTotalCount() API, not reset here
                vm.slaCompliancePerc = 0;
                vm.avgResolutionTime = 0;
                vm.avgResolutionHours = 0;
                vm.avgResponseTime = 0;
                vm.avgResponseHours = 0;
                
                if (!apiResponse) {
                    console.warn('No API response data');
                    return;
                }
                
                // Extract priorityTotals if available in API response
                if (apiResponse.priorityTotals) {
                    vm.priorityTotals = apiResponse.priorityTotals;
                    // console.log('>>> priorityTotals extracted from API:', vm.priorityTotals);
                }
                
                // Process Breach cases
                if (apiResponse.breach && apiResponse.breach.data && Array.isArray(apiResponse.breach.data)) {
                    vm.slaBreachCount = apiResponse.breach.count || apiResponse.breach.data.length;
                    apiResponse.breach.data.forEach(function(item) {
                        vm.slaBreaches.push({
                            incidentId: item.caseId,
                            state: item.state || '-',
                            district: item.district || '-',
                            block: item.block || '-',
                            type: item.status || '-',
                            reportedDate: new Date(),
                            status: 'Breach',
                            slaDue: removeSeconds(item.breachTime || '-'),
                            resolutionDate: new Date(),
                            slaStatus: 'Breach',
                            assignedTo: item.assignedTo || '-',
                            caseStatus: item.caseStatus || '-',
                            ticketId: item.ticketId || null,
                            gpStatus: abbreviateGPStatus(item.gpStatus || '-'),
                            gpLocation: item.gpLocation || '-',
                            createdDate: item.createdDate ? new Date(item.createdDate) : null,
                            description: item.description || item.title || '-',
                            baName: item.baName || '-',
                            oaName: item.oaName || '-',
                            caseTypeName: item.caseTypeName || '-'
                        });
                    });
                }
                
                // Process Near To Breach cases
                vm.nearToBreachIncidents = [];
                if (apiResponse.nearToBreach && apiResponse.nearToBreach.data && Array.isArray(apiResponse.nearToBreach.data)) {
                    vm.nearToBreachCount = apiResponse.nearToBreach.count || apiResponse.nearToBreach.data.length;
                    apiResponse.nearToBreach.data.forEach(function(item) {
                        var nearToBreachItem = {
                            incidentId: item.caseId,
                            state: item.state || '-',
                            district: item.district || '-',
                            block: item.block || '-',
                            type: item.status || '-',
                            reportedDate: new Date(),
                            status: 'Near To Breach',
                            slaDue: removeSeconds(item.remainingTime || '-'),
                            resolutionDate: new Date(),
                            slaStatus: 'Nearing Breach',
                            assignedTo: item.assignedTo || '-',
                            caseStatus: item.caseStatus || '-',
                            ticketId: item.ticketId || null,
                            gpStatus: abbreviateGPStatus(item.gpStatus || '-'),
                            gpLocation: item.gpLocation || '-',
                            createdDate: item.createdDate ? new Date(item.createdDate) : null,
                            description: item.description || item.title || '-',
                            baName: item.baName || '-',
                            oaName: item.oaName || '-',
                            caseTypeName: item.caseTypeName || '-'
                        };
                        vm.nearToBreachIncidents.push(nearToBreachItem);
                        vm.slaBreaches.push(nearToBreachItem);
                    });
                }
                
                // Process Open Cases (ASSIGNED, TO_BE_ASSIGNED, IN_PROGRESS)
                vm.openIncidents = [];
                if (apiResponse.openCaseData && Array.isArray(apiResponse.openCaseData)) {
                    apiResponse.openCaseData.forEach(function(item) {
                        vm.openIncidents.push({
                            incidentId: item.id || item.caseId || '-',
                            state: item.state || '-',
                            district: item.district || '-',
                            block: item.block || '-',
                            type: item.priority || '-',
                            reportedDate: item.createDate ? new Date(item.createDate) : new Date(),
                            assignedTo: item.assignedToUser || '-',
                            caseStatus: item.status || '-',
                            ticketId: item.ticketId || null,
                            gpStatus: abbreviateGPStatus(item.gpStatus || '-'),
                            gpLocation: item.gpLocation || '-',
                            createdDate: item.createDate ? new Date(item.createDate) : null,
                            dueDate: item.dueDate ? new Date(item.dueDate) : null,
                            description: item.description || '-',
                            rca: item.rca || '-',
                            baName: item.baName || '-',
                            oaName: item.oaName || '-',
                            caseTypeName: item.caseTypeName || '-'
                        });
                    });
                }
                
                // Process Resolved Cases
                vm.resolvedIncidents = [];
                if (apiResponse.resovedcaseData && Array.isArray(apiResponse.resovedcaseData)) {
                    apiResponse.resovedcaseData.forEach(function(item) {
                        vm.resolvedIncidents.push({
                            incidentId: item.id || item.caseId || '-',
                            state: item.state || '-',
                            district: item.district || '-',
                            block: item.block || '-',
                            type: item.priority || item.priorityType || item.priorityName || item.type || '-',
                            reportedDate: item.createDate ? new Date(item.createDate) : new Date(),
                            assignedTo: item.assignedToUser || '-',
                            caseStatus: item.status || '-',
                            ticketId: item.ticketId || null,
                            gpStatus: abbreviateGPStatus(item.gpStatus || '-'),
                            gpLocation: item.gpLocation || '-',
                            createdDate: item.createDate ? new Date(item.createDate) : null,
                            dueDate: item.dueDate ? new Date(item.dueDate) : null,
                            description: item.description || item.title || item.caseTitle || '-',
                            rca: item.rca || '-',
                            baName: item.baName || '-',
                            oaName: item.oaName || '-',
                            caseTypeName: item.caseTypeName || '-'
                        });
                    });
                }
                
                // Process No Action cases
                if (apiResponse.noAction && apiResponse.noAction.data && Array.isArray(apiResponse.noAction.data)) {
                    vm.noActionCount = apiResponse.noAction.count || apiResponse.noAction.data.length;
                }
                // SLA Compliance percentage from API if available
                if (apiResponse && typeof apiResponse.resolvedInTimePerc !== 'undefined' && apiResponse.resolvedInTimePerc !== null) {
                  //  vm.slaCompliancePerc = apiResponse.resolvedInTimePerc;
                }
                
                // Populate MTTR Details table from resolved case data and mttrdata mapping
                vm.mttrDetails = [];
                var mttrDataMap = {}; // Map caseNumber to mttrdata rows for quick lookup
                
                // Build map from mttrdata
                if (apiResponse && apiResponse.mttrdata && Array.isArray(apiResponse.mttrdata)) {
                    apiResponse.mttrdata.forEach(function(item) {
                        var caseNumber = item && item.caseNumber ? String(item.caseNumber) : '';
                        if (caseNumber) {
                            if (!mttrDataMap[caseNumber]) {
                                mttrDataMap[caseNumber] = [];
                            }
                            mttrDataMap[caseNumber].push(item);
                        }
                    });
                }
                
                // Populate MTTR table from resolved cases with mttrdata enrichment
                if (apiResponse && apiResponse.resovedcaseData && Array.isArray(apiResponse.resovedcaseData)) {
                    apiResponse.resovedcaseData.forEach(function(resolvedCase) {
                        var createdDate = resolvedCase.createDate ? new Date(resolvedCase.createDate) : null;
                        var resolvedCaseTicketId = resolvedCase.ticketId ? String(resolvedCase.ticketId) : '';
                        
                        // Match corresponding MTTR data using ticketId/caseNumber and createDate/caseCreatedDate
                        var mttrCandidates = resolvedCaseTicketId ? (mttrDataMap[resolvedCaseTicketId] || []) : [];
                        var mttrData = null;

                        for (var mttrIndex = 0; mttrIndex < mttrCandidates.length; mttrIndex++) {
                            var candidate = mttrCandidates[mttrIndex];
                            if (isSameCaseDateTime(resolvedCase.createDate, candidate && candidate.caseCreatedDate)) {
                                mttrData = candidate;
                                break;
                            }
                        }

                        var resolvedDate = mttrData && mttrData.resolvedTime ? parseDateTimeValue(mttrData.resolvedTime) : null;
                        var resolutionTime = mttrData ? mttrData.createdDateToResolvedH : '-';
                        
                        // Calculate resolution hours for SLA comparison
                        var resolvedHours = 99; // Default high value for breach
                        if (mttrData) {
                            resolvedHours = extractHours(mttrData.createdDateToResolvedH);
                        }
                        
                        vm.mttrDetails.push({
                            incidentId: resolvedCase.id || resolvedCase.caseId || '-',
                            createdDate: createdDate,
                            createdTime: createdDate ? formatTime(createdDate) : '-',
                            resolvedDate: resolvedDate,
                            resolvedTime: resolvedDate ? formatTime(resolvedDate) : '-',
                            resolutionTime: resolutionTime,
                            slaStatus: !isNaN(resolvedHours) && resolvedHours <= 8 ? 'Within SLA' : 'After SLA',
                            ticketId: resolvedCase.ticketId || '-',
                            title: resolvedCase.description || '-',
                            district: resolvedCase.district || '-',
                            block: resolvedCase.block || '-',
                            gpLocation: resolvedCase.gpLocation || '-',
                            incidentStatus: resolvedCase.status || '-',
                            rca: resolvedCase.rca || (mttrData && mttrData.rca ? mttrData.rca : '-'),
                            state: resolvedCase.state || '-',
                            priority: resolvedCase.priority || '-',
                            assignedTo: resolvedCase.assignedToUser || '-',
                            gpStatus: abbreviateGPStatus(resolvedCase.gpStatus || '-'),
                            baName: resolvedCase.baName || '-',
                            oaName: resolvedCase.oaName || '-',
                            caseTypeName: resolvedCase.caseTypeName || '-'
                        });
                    });
                }
                
                // Avg. Response/Resolution Time from mttrdata
                var totalResolvedHours = 0;
                var totalResponseHours = 0;
                var resolvedWithinSLACount = 0;
                
                if (apiResponse && apiResponse.mttrdata && Array.isArray(apiResponse.mttrdata)) {
                    apiResponse.mttrdata.forEach(function(item) {
                        var resolvedHours = extractHours(item && item.createdDateToResolvedH);
                        var responseHours = extractHours(item && item.resolutionTimeH);
                        
                        if (!isNaN(resolvedHours)) {
                            totalResolvedHours += resolvedHours;
                            // Count cases resolved within SLA (8 hours)
                            if (resolvedHours <= 8) {
                                resolvedWithinSLACount++;
                            }
                        }
                        if (!isNaN(responseHours)) {
                            totalResponseHours += responseHours;
                        }
                    });
                    
                    var mttrCount = apiResponse.mttrdata.length;
                    
                    // Set resolved within time count from mttrdata where createdDateToResolvedH <= 8
                    vm.resolvedwithinTimeCount = resolvedWithinSLACount;
                    
                    // Try to calculate immediately if priorityTotals is already available
                    recalculateSLACompliance();
                    var avgResolvedHours = mttrCount > 0 ? (totalResolvedHours / mttrCount) : 0;
                    var avgResponseHours = mttrCount > 0 ? (totalResponseHours / mttrCount) : 0;
                    var roundedAvgResolvedHours = roundHoursByMinutes(avgResolvedHours);
                    var roundedAvgResponseHours = roundHoursByMinutes(avgResponseHours);
                    vm.avgResolutionTime = roundedAvgResolvedHours;
                    vm.avgResolutionHours = roundedAvgResolvedHours;
                    vm.avgResponseTime = roundedAvgResponseHours;
                    vm.avgResponseHours = roundedAvgResponseHours;
                } else {
                    vm.avgResolutionTime = 0;
                    vm.avgResolutionHours = 0;
                    vm.avgResponseTime = 0;
                    vm.avgResponseHours = 0;
                }

                // Update MTTR details pagination
                vm.mttrDetailsTotalItems = (vm.mttrDetails || []).length;
                vm.mttrDetailsQueryCount = vm.mttrDetailsTotalItems;
                vm.mttrDetailsPage = 1;
                vm.updatePagedMttrDetails();

                // Get GP Down count directly from API response
                if (apiResponse && typeof apiResponse.gpDown !== 'undefined' && apiResponse.gpDown !== null) {
                    vm.gpDownCount = apiResponse.gpDown;
                } else {
                    vm.gpDownCount = 0;
                }

                if (apiResponse && apiResponse.blockDownData) {
                    vm.totalBlockCount = apiResponse.blockDownData.totalBlockCount || 0;
                    vm.blockDownCount = apiResponse.blockDownData.totalBlockDownCount || 0;
                } else {
                    vm.totalBlockCount = 0;
                    vm.blockDownCount = 0;
                }

                // GP Down list from API response
                if (apiResponse && Array.isArray(apiResponse.gpDownList)) {
                    vm.gpDownList = apiResponse.gpDownList.map(function(item) {
                        var createdMs = item && item.caseCreatedTime ? new Date(item.caseCreatedTime).getTime() : NaN;
                        var durationMinutes = isNaN(createdMs) ? 0 : Math.max(0, Math.floor((Date.now() - createdMs) / (1000 * 60)));
                        return angular.extend({}, item, {
                            gpDownDurationMinutes: durationMinutes
                        });
                    });
                } else {
                    vm.gpDownList = [];
                }

                if (apiResponse && apiResponse.blockDownData && Array.isArray(apiResponse.blockDownData.blockTicketsList)) {
                    vm.blockDownList = apiResponse.blockDownData.blockTicketsList.map(function(item) {
                        return angular.extend({}, item, {
                            createdDate: item.createDate ? new Date(item.createDate) : null,
                            dueDate: item.dueDate ? new Date(item.dueDate) : null,
                            caseStatus: item.status || '-',
                            assignedTo: item.assignedToUser || '-',
                            incidentId: item.id || item.caseId || '-',
                            ticketId: item.ticketId || null
                        });
                    });
                } else {
                    vm.blockDownList = [];
                }

                // Update GP Down pagination
                vm.gpDownTotalItems = (vm.gpDownList || []).length;
                vm.gpDownQueryCount = vm.gpDownTotalItems;
                vm.gpDownPage = 1;
                vm.updatePagedGpDown();

                vm.blockDownTotalItems = (vm.blockDownList || []).length;
                vm.blockDownQueryCount = vm.blockDownTotalItems;
                vm.blockDownPage = 1;
                vm.updatePagedBlockDown();
                
                // Update pagination totals and slice
                vm.totalItems = (vm.slaBreaches || []).length;
                vm.queryCount = vm.totalItems;
                vm.page = 1;
                vm.updatePagedSLA();
                
                // Update open incidents pagination
                vm.openIncidentsTotalItems = (vm.openIncidents || []).length;
                vm.openIncidentsQueryCount = vm.openIncidentsTotalItems;
                vm.openIncidentsPage = 1;
                vm.updatePagedOpenIncidents();
                
                // Update resolved incidents pagination
                vm.resolvedIncidentsTotalItems = (vm.resolvedIncidents || []).length;
                vm.resolvedIncidentsQueryCount = vm.resolvedIncidentsTotalItems;
                vm.resolvedIncidentsPage = 1;
                vm.updatePagedResolvedIncidents();
                
                // Update near to breach incidents pagination
                vm.nearToBreachTotalItems = (vm.nearToBreachIncidents || []).length;
                vm.nearToBreachQueryCount = vm.nearToBreachTotalItems;
                vm.nearToBreachPage = 1;
                vm.updatePagedNearToBreach();
                vm.page = 1;
                vm.updatePagedSLA();
                renderResponseTimeChart();
                
            } catch (e) {
                console.error('Error in transformAndDisplaySLAData:', e);
                vm.slaBreaches = [];
                vm.totalItems = 0;
                vm.queryCount = 0;
                vm.page = 1;
                vm.updatePagedSLA();
            }
        };
        
        function formatDate(dateStr) {
            var d = new Date(dateStr);
            var month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            return month[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
        }

        function formatTime(date) {
            if (!date || !(date instanceof Date)) return '-';
            var hours = String(date.getHours()).padStart(2, '0');
            var minutes = String(date.getMinutes()).padStart(2, '0');
            var seconds = String(date.getSeconds()).padStart(2, '0');
            return hours + ':' + minutes + ':' + seconds;
        }

        function parseDateTimeValue(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }
            if (value instanceof Date) {
                return isNaN(value.getTime()) ? null : value;
            }
            if (typeof value === 'number') {
                var numberDate = new Date(value);
                return isNaN(numberDate.getTime()) ? null : numberDate;
            }

            var str = String(value).trim();
            if (!str) {
                return null;
            }

            var normalized = str.replace(' ', 'T');
            var parsedDate = new Date(normalized);
            if (!isNaN(parsedDate.getTime())) {
                return parsedDate;
            }

            var match = str.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?$/);
            if (match) {
                return new Date(
                    parseInt(match[1], 10),
                    parseInt(match[2], 10) - 1,
                    parseInt(match[3], 10),
                    parseInt(match[4], 10),
                    parseInt(match[5], 10),
                    parseInt(match[6], 10),
                    parseInt((match[7] || '0').padEnd(3, '0'), 10)
                );
            }

            return null;
        }

        function isSameCaseDateTime(resolvedCaseCreateDate, mttrCaseCreatedDate) {
            var resolvedDate = parseDateTimeValue(resolvedCaseCreateDate);
            var mttrDate = parseDateTimeValue(mttrCaseCreatedDate);

            if (!resolvedDate || !mttrDate) {
                return false;
            }

            return resolvedDate.getTime() === mttrDate.getTime();
        }

        function extractHours(value) {
            if (value === null || value === undefined) { return 0; }
            if (typeof value === 'number') { return value; }
            var str = String(value);
            var m = str.match(/(\d+)\s*hrs?/i);
            if (m && m[1]) { return parseInt(m[1], 10) || 0; }
            var n = parseFloat(str);
            if (!isNaN(n)) { return n; }
            return 0;
        }

        function roundHoursByMinutes(hours) {
            if (hours === null || hours === undefined || isNaN(hours)) { return 0; }
            var totalMinutes = Math.round(hours * 60);
            var roundedHours = totalMinutes / 60;
            return parseFloat(roundedHours.toFixed(2));
        }

        // Function to recalculate SLA compliance when priorityTotals is updated
        function recalculateSLACompliance() {
            // Check if resolvedwithinTimeCount is defined (allow 0 as valid value)
            if (vm.resolvedwithinTimeCount === undefined || vm.resolvedwithinTimeCount === null) {
                return; // No data yet
            }
            
            var priorityTotals = vm.priorityTotals || {};
            var totalCount = (priorityTotals.ASSIGNED || 0) + 
                             (priorityTotals.TOBEASSIGNED || 0) + 
                             (priorityTotals.RESOLVED || 0) + 
                             (priorityTotals.INPROGRESS || 0) + 
                             (priorityTotals.PENDING || 0) + 
                             (priorityTotals.CLOSED || 0);
            
            vm.slaCompliancePerc = totalCount > 0 ? (vm.resolvedwithinTimeCount / totalCount) * 100 : 0;
        }

        vm.opertionalAreaSelect = function (businessAreaId) {

            if (!businessAreaId) {
                // Business Area was cleared - fall back to state-level data
                if (vm.selectedState) {
                    vm.onStateChange(vm.selectedState);
                }
                return;
            }

            // Set flag to prevent watcher from also loading data
            isLoadingViaHandler = true;
            
            // reset dependent filters when BA changes
            vm.lastFilterChanged = null; // Reset to use hierarchical priority
            vm.selectedOperationalAreaName = null;
            vm.selectedDistrict = null;
            vm.selectedBlock = null;
            vm.selectedGP = null;
            vm.districtList = [];
            vm.blockList = [];
            vm.gpList = [];

            getIncidentData.getOperationalArea(businessAreaId, function (response) {
                vm.operationalAreaName = response.data;
            });

            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;

            getIncidentData.getGeofenceIncidents(
                businessAreaId,
                fromTS,
                toTS,
                vm.selectedAMCStatus,
                function (priorityResp) {

                    getIncidentData.getGeofenceIncident(
                        businessAreaId,
                        fromTS,
                        toTS,
                        vm.selectedAMCStatus,
                        function (statusResp) {

                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);

                        });
                }
            );
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Reset flag after a short delay to allow watchers to settle
            $timeout(function() {
                isLoadingViaHandler = false;
            }, 100);

        };

        vm.onOperationalAreaChange = function (operationalAreaId) {
            isLoadingViaHandler = true;
            
            vm.lastFilterChanged = null; // Reset to use hierarchical priority
            vm.selectedDistrict = null;
            vm.selectedBlock = null;
            vm.selectedGP = null;
            vm.blockList = [];
            vm.districtList = [];
            vm.gpList = [];

            if (!operationalAreaId) {
                // Operational Area was cleared - fall back to Business Area level if available
                if (vm.selectedBusinessArea) {
                    vm.opertionalAreaSelect(vm.selectedBusinessArea);
                }
                isLoadingViaHandler = false;
                return;
            }

            getIncidentData.getDistrict(operationalAreaId, function (response) {
                vm.districtList = response.data || response;
            });

            vm.triggerAPICall();
            
            // Debounce the SLA data loading to avoid race conditions
            debounceFilterChange(function() {
                loadSLADataWithCancellation();
                vm.loadRoleCounts();
                vm.loadGPTotalCount();
                vm.loadDayWiseTrendData();
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onDistrictChange = function (districtId) {
            isLoadingViaHandler = true;
            
            vm.lastFilterChanged = null; // Reset to use hierarchical priority
            vm.selectedBlock = null;
            vm.selectedGP = null;
            vm.blockList = [];
            vm.gpList = [];

            if (!districtId) {
                // District was cleared - fall back to Operational Area level if available
                if (vm.selectedOperationalAreaName) {
                    vm.onOperationalAreaChange(vm.selectedOperationalAreaName);
                }
                isLoadingViaHandler = false;
                return;
            }
            
            getIncidentData.getBlocks(districtId, function (response) {
                vm.blockList = response.data || response;
            });

            // Get date range for API calls
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;


            if (typeof getIncidentData.getIncidentsData === 'function' && typeof getIncidentData.getStatusData === 'function') {
                getIncidentData.getIncidentsData(districtId, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                    getIncidentData.getStatusData(districtId, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                        mergeData(priorityResp.data, statusResp.data);
                        prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);
                        });
                    });
                } else {
                    console.error('getIncidentsData/getStatusData not available on getIncidentData service');
                }
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Debounce to prevent race conditions
            debounceFilterChange(function() {
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onBlockChange = function (blockId) {
            isLoadingViaHandler = true;
            
            vm.lastFilterChanged = null; // Reset to use hierarchical priority
            // Reset GP list when block changes
            vm.selectedGP = null;
            vm.gpList = [];
            
            if (!blockId) {
                // Block was cleared - fall back to District level if available
                if (vm.selectedDistrict) {
                    vm.onDistrictChange(vm.selectedDistrict);
                }
                isLoadingViaHandler = false;
                return;
            }
            
            // Load GP list for the selected block
            if (typeof getIncidentData.getGPListByBlock === 'function') {
                getIncidentData.getGPListByBlock(blockId, vm.selectedAMCStatus, function(response) {
                    if (response && response.data && response.data && Array.isArray(response.data)) {
                        vm.gpList = response.data.map(function(gp) {
                            return {
                                id: gp.id,
                                name: gp.name
                            };
                        });
                        // console.log('GP list loaded:', vm.gpList.length, 'GPs');
                    } else {
                        console.warn('No GP data in response:', response);
                        vm.gpList = [];
                    }
                });
            }
            
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;

            if (typeof getIncidentData.getIncidentsDataBlock === 'function' && 
                typeof getIncidentData.getStatusDataBlock === 'function') {
                getIncidentData.getIncidentsDataBlock(blockId, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                    getIncidentData.getStatusDataBlock(blockId, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                        mergeData(priorityResp.data, statusResp.data);
                        prepareBusinessAreaCases();
                        calculateTotals();
                        $timeout(renderAllBusinessAreaCharts, 500);
                    });
                });
            } else {
                console.error('getIncidentsDataBlock/getStatusDataBlock not available on getIncidentData service');
            }
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Debounce to prevent race conditions
            debounceFilterChange(function() {
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onPackageChange = function (packageId) {
            isLoadingViaHandler = true;
            
            // console.log('onPackageChange called with packageId:', packageId, 'selectedState:', vm.selectedState);
            vm.lastFilterChanged = 'package'; // Track that package was changed
            
            // Reset state when package changes and reload states for new package
            vm.selectedState = null;
            loadStatesForPackage(packageId);
            
            // Reset hierarchical filters when package is changed
            vm.selectedGP = null;
            vm.gpList = [];
            
            if (!packageId) return;
            
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;
            
            // console.log('Package change - fromTS:', fromTS, 'toTS:', toTS);
            
            // If both package and state are selected, call both APIs
            if (packageId && vm.selectedState) {
                // console.log('Calling getIncidentsbyPackageAndState and getStatusbyPackageAndState');
                getIncidentData.getIncidentsbyPackageAndState(
                    packageId,
                    vm.selectedState,
                    fromTS,
                    toTS,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        // console.log('getIncidentsbyPackageAndState response:', priorityResp);
                        getIncidentData.getStatusbyPackageAndState(
                            packageId,
                            vm.selectedState,
                            fromTS,
                            toTS,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                // console.log('getStatusbyPackageAndState response:', statusResp);
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            } 
            // If only package is selected, call both package APIs
            else if (packageId) {
                // console.log('Calling getIncidentsbyPackage and getStatusbyPackage');
                getIncidentData.getIncidentsbyPackage(
                    fromTS,
                    toTS,
                    packageId,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        // console.log('getIncidentsbyPackage response:', priorityResp);
                        getIncidentData.getStatusbyPackage(
                            fromTS,
                            toTS,
                            packageId,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                // console.log('getStatusbyPackage response:', statusResp);
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            }
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Debounce to prevent race conditions
            debounceFilterChange(function() {
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onStateChange = function (stateId) {
            isLoadingViaHandler = true;
            
            // console.log('onStateChange called with stateId:', stateId, 'selectedPackage:', vm.selectedPackage);
            vm.lastFilterChanged = 'state'; // Track that state was changed
            
            // Reset hierarchical filters when state is changed
            vm.selectedBusinessArea = null;
            vm.selectedOperationalAreaName = null;
            vm.selectedDistrict = null;
            vm.selectedBlock = null;
            vm.selectedGP = null;
            vm.businessAreaName = [];
            vm.operationalAreaName = [];
            vm.districtList = [];
            vm.blockList = [];
            vm.gpList = [];
            
            if (!stateId) {
                // State was cleared - fall back to package-level data
                if (vm.selectedPackage) {
                    vm.onPackageChange(vm.selectedPackage);
                }
                isLoadingViaHandler = false;
                return;
            }
            
            // Load business areas for the selected state and package
            if (vm.selectedPackage && stateId) {
                getIncidentData.getBusinessArea(stateId, vm.selectedPackage, function (response) {
                    if (response.data) {
                        vm.businessAreaName = response.data.baList || [];
                    }
                });
            }
            
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;
            
            // console.log('State change - fromTS:', fromTS, 'toTS:', toTS);
            
            // If both package and state are selected, call both APIs
            if (vm.selectedPackage && stateId) {
                // console.log('Calling getIncidentsbyPackageAndState and getStatusbyPackageAndState');
                getIncidentData.getIncidentsbyPackageAndState(
                    vm.selectedPackage,
                    stateId,
                    fromTS,
                    toTS,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        // console.log('getIncidentsbyPackageAndState response:', priorityResp);
                        getIncidentData.getStatusbyPackageAndState(
                            vm.selectedPackage,
                            stateId,
                            fromTS,
                            toTS,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                // console.log('getStatusbyPackageAndState response:', statusResp);
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            }
            // If only state is selected, you might want to handle this case
            // For now, just reload SLA data
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Debounce to prevent race conditions
            debounceFilterChange(function() {
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onGPChange = function (gpId) {
            isLoadingViaHandler = true;
            
            // console.log('onGPChange called with gpId:', gpId);
            vm.lastFilterChanged = null; // Reset to use hierarchical priority
            
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;
            
            if (!gpId) {
                // GP was cleared - fall back to Block level if available
                if (vm.selectedBlock) {
                    vm.onBlockChange(vm.selectedBlock);
                }
                isLoadingViaHandler = false;
                return;
            }
            
            // Call both priority and status APIs for GP
            if (typeof getIncidentData.getIncidentsDataGP === 'function' && 
                typeof getIncidentData.getStatusDataGP === 'function') {
                getIncidentData.getIncidentsDataGP(gpId, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                    getIncidentData.getStatusDataGP(gpId, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                        if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);
                        }
                    });
                });
            } else {
                console.error('getIncidentsDataGP/getStatusDataGP not available on getIncidentData service');
            }
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Debounce to prevent race conditions
            debounceFilterChange(function() {
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onCaseTypeChange = function (caseTypeId) {
            vm.onAlertTypeChange();
        };

        vm.onAMCStatusChange = function (amcStatus) {
            isLoadingViaHandler = true;
            vm.selectedAMCStatus = amcStatus || vm.selectedAMCStatus || 'ALL';
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;

            function reloadDashboardForActiveFilter() {
                // Reload by most specific active filter to avoid wrong endpoint selection
                if (vm.selectedGP) {
                    getIncidentData.getIncidentsDataGP(vm.selectedGP, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusDataGP(vm.selectedGP, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                mergeData(priorityResp.data, statusResp.data);
                                prepareBusinessAreaCases();
                                calculateTotals();
                                $timeout(renderAllBusinessAreaCharts, 500);
                            }
                        });
                    });
                } else if (vm.selectedBlock) {
                    getIncidentData.getIncidentsDataBlock(vm.selectedBlock, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusDataBlock(vm.selectedBlock, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                mergeData(priorityResp.data, statusResp.data);
                                prepareBusinessAreaCases();
                                calculateTotals();
                                $timeout(renderAllBusinessAreaCharts, 500);
                            }
                        });
                    });
                } else if (vm.selectedDistrict) {
                    getIncidentData.getIncidentsData(vm.selectedDistrict, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusData(vm.selectedDistrict, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                mergeData(priorityResp.data, statusResp.data);
                                prepareBusinessAreaCases();
                                calculateTotals();
                                $timeout(renderAllBusinessAreaCharts, 500);
                            }
                        });
                    });
                } else if (vm.selectedOperationalAreaName || vm.selectedBusinessArea) {
                    vm.triggerAPICall();
                } else if (vm.selectedPackage && vm.selectedState) {
                    getIncidentData.getIncidentsbyPackageAndState(
                        vm.selectedPackage,
                        vm.selectedState,
                        fromTS,
                        toTS,
                        vm.selectedAMCStatus,
                        function (priorityResp) {
                            getIncidentData.getStatusbyPackageAndState(
                                vm.selectedPackage,
                                vm.selectedState,
                                fromTS,
                                toTS,
                                vm.selectedAMCStatus,
                                function (statusResp) {
                                    if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                        mergeData(priorityResp.data, statusResp.data);
                                        prepareBusinessAreaCases();
                                        calculateTotals();
                                        $timeout(renderAllBusinessAreaCharts, 500);
                                    }
                                }
                            );
                        }
                    );
                } else if (vm.selectedPackage) {
                    getIncidentData.getIncidentsbyPackage(
                        fromTS,
                        toTS,
                        vm.selectedPackage,
                        vm.selectedAMCStatus,
                        function (priorityResp) {
                            getIncidentData.getStatusbyPackage(
                                fromTS,
                                toTS,
                                vm.selectedPackage,
                                vm.selectedAMCStatus,
                                function (statusResp) {
                                    if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                        mergeData(priorityResp.data, statusResp.data);
                                        prepareBusinessAreaCases();
                                        calculateTotals();
                                        $timeout(renderAllBusinessAreaCharts, 500);
                                    }
                                }
                            );
                        }
                    );
                }

                vm.loadSLABreachData();
                vm.loadRoleCounts();
                vm.loadGPTotalCount();
                vm.loadDayWiseTrendData();

                // Debounce to prevent race conditions
                debounceFilterChange(function() {
                    isLoadingViaHandler = false;
                }, 200);
            }

            // AMC status filter changed, reload data with the selected filter
            // If block is selected, reload GP list with new AMC status
            if (vm.selectedBlock) {
                if (typeof getIncidentData.getGPListByBlock === 'function') {
                    getIncidentData.getGPListByBlock(vm.selectedBlock, vm.selectedAMCStatus, function(response) {
                        if (response && response.data && Array.isArray(response.data)) {
                            vm.gpList = response.data.map(function(gp) {
                                return {
                                    id: gp.id,
                                    name: gp.name
                                };
                            });
                            // Clear selected GP if it's no longer in the updated list
                            if (vm.selectedGP) {
                                var gpExists = vm.gpList.some(function(gp) {
                                    return gp.id === vm.selectedGP;
                                });
                                if (!gpExists) {
                                    vm.selectedGP = null;
                                }
                            }
                        } else {
                            vm.gpList = [];
                            vm.selectedGP = null;
                        }

                        reloadDashboardForActiveFilter();
                    });

                    return;
                }
            }

            reloadDashboardForActiveFilter();
        };

        vm.applyDateRange = function () {
            // Cancel any pending requests to prevent race conditions
            cancelPendingRequests();
            
            // Validate dates
            if (!vm.fromDate || !vm.toDate) {
                vm.dateValidationError = 'Please select both From Date and To Date';
                return;
            }
            
            var fromTime = new Date(vm.fromDate).getTime();
            var toTime = new Date(vm.toDate).getTime();
            
            // Validate timestamps
            if (isNaN(fromTime) || isNaN(toTime)) {
                vm.dateValidationError = 'Invalid date format. Please select valid dates.';
                return;
            }
            
            if (fromTime > toTime) {
                vm.dateValidationError = 'From Date cannot be greater than To Date';
                return;
            }
            
            // If we reach here, dates are valid, clear any error
            vm.dateValidationError = null;
            
            if (vm.fromDate && vm.toDate) {
                vm.dateRange = formatDate(vm.fromDate) + " - " + formatDate(vm.toDate);
            }
            vm.showDatePopup = false;

            var fromTS = fromTime;
            var toTS = toTime;

            // Determine most specific active filter
            // Priority: GP > Block > District > OA > BA > Package+State > Package > State > None
            var mostSpecificFilter = null;
            if (vm.selectedGP) {
                mostSpecificFilter = 'gp';
            } else if (vm.selectedBlock) {
                mostSpecificFilter = 'block';
            } else if (vm.selectedDistrict) {
                mostSpecificFilter = 'district';
            } else if (vm.selectedOperationalAreaName) {
                mostSpecificFilter = 'oa';
            } else if (vm.selectedBusinessArea) {
                mostSpecificFilter = 'ba';
            } else if (vm.selectedPackage && vm.selectedState) {
                mostSpecificFilter = 'packageState';
            } else if (vm.selectedPackage) {
                mostSpecificFilter = 'package';
            } else if (vm.selectedState) {
                mostSpecificFilter = 'state';
            }

            // Trigger appropriate data API calls based on most specific active filter
            if (mostSpecificFilter === 'gp') {
                if (typeof getIncidentData.getIncidentsDataGP === 'function' && 
                    typeof getIncidentData.getStatusDataGP === 'function') {
                    getIncidentData.getIncidentsDataGP(vm.selectedGP, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusDataGP(vm.selectedGP, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);
                        });
                    });
                }
            } else if (mostSpecificFilter === 'block') {
                if (typeof getIncidentData.getIncidentsDataBlock === 'function' && 
                    typeof getIncidentData.getStatusDataBlock === 'function') {
                    getIncidentData.getIncidentsDataBlock(vm.selectedBlock, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusDataBlock(vm.selectedBlock, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);
                        });
                    });
                }
            } else if (mostSpecificFilter === 'district') {
                if (typeof getIncidentData.getIncidentsData === 'function' && 
                    typeof getIncidentData.getStatusData === 'function') {
                    getIncidentData.getIncidentsData(vm.selectedDistrict, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusData(vm.selectedDistrict, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);
                        });
                    });
                }
            } else if (mostSpecificFilter === 'packageState') {
                getIncidentData.getIncidentsbyPackageAndState(
                    vm.selectedPackage,
                    vm.selectedState,
                    fromTS,
                    toTS,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        getIncidentData.getStatusbyPackageAndState(
                            vm.selectedPackage,
                            vm.selectedState,
                            fromTS,
                            toTS,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            } else if (mostSpecificFilter === 'package') {
                getIncidentData.getIncidentsbyPackage(
                    fromTS,
                    toTS,
                    vm.selectedPackage,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        getIncidentData.getStatusbyPackage(
                            fromTS,
                            toTS,
                            vm.selectedPackage,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            } else if (mostSpecificFilter === 'state') {
                getIncidentData.getIncidentsbyPackageAndState(
                    vm.selectedPackage || 0,
                    vm.selectedState,
                    fromTS,
                    toTS,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        getIncidentData.getStatusbyPackageAndState(
                            vm.selectedPackage || 0,
                            vm.selectedState,
                            fromTS,
                            toTS,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            } else {
                // Default: BA/OA level or no filters
                vm.triggerAPICall();
            }

            // Always trigger these additional API calls
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
        }

        // Debounced data reload function to prevent race conditions
        vm.debouncedReloadData = function() {
            // Cancel any pending debounce timer
            if (filterChangeDebounceTimer) {
                $timeout.cancel(filterChangeDebounceTimer);
            }
            
            // Set a new debounce timer (500ms delay)
            filterChangeDebounceTimer = $timeout(function() {
                // Only reload if we have valid dates
                if (vm.fromDate && vm.toDate) {
                    var fromTime = new Date(vm.fromDate).getTime();
                    var toTime = new Date(vm.toDate).getTime();
                    
                    // Validate date range before reloading
                    if (!isNaN(fromTime) && !isNaN(toTime) && fromTime <= toTime) {
                        vm.applyDateRange();
                    }
                }
            }, 500);
        };

        // Watch for filter changes and trigger data reload
        // This ensures data consistency when filters change programmatically or via UI
        $scope.$watchGroup([
            function() { return vm.selectedPackage; },
            function() { return vm.selectedState; },
            function() { return vm.selectedBusinessArea; },
            function() { return vm.selectedOperationalAreaName; },
            function() { return vm.selectedDistrict; },
            function() { return vm.selectedBlock; },
            function() { return vm.selectedGP; },
            function() { return vm.selectedAMCStatus; },
            function() { return vm.fromDate; },
            function() { return vm.toDate; }
        ], function(newValues, oldValues, scope) {
            // Skip if data is already being loaded by ng-change handlers
            if (isLoadingViaHandler) {
                return;
            }
            
            // Skip the initial trigger when controller loads
            if (newValues === oldValues) {
                return;
            }
            
            // Check if any filter actually changed
            var hasChanged = false;
            for (var i = 0; i < newValues.length; i++) {
                if (newValues[i] !== oldValues[i]) {
                    hasChanged = true;
                    break;
                }
            }
            
            if (hasChanged) {
                // Use debounced reload to prevent rapid-fire requests
                vm.debouncedReloadData();
            }
        });

        // Apply defaults on load
        $timeout(function () {
            vm.applyDateRange();
        }, 0);
        vm.incidentData = []
        vm.triggerAPICall = function () {
            if (!vm.selectedBusinessArea) {
                return;
            }

            var fromTS = new Date(vm.fromDate).getTime();
            var toTS = new Date(vm.toDate).getTime();

            var oaId = vm.selectedOperationalAreaName || null;

            getIncidentData.getIncidents(
                vm.selectedBusinessArea,
                fromTS,
                toTS,
                oaId,
                vm.selectedAMCStatus,
                function (priorityResp) {

                    getIncidentData.getStatus(
                        vm.selectedBusinessArea,
                        fromTS,
                        toTS,
                        oaId,
                        vm.selectedAMCStatus,
                        function (statusResp) {

                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);

                        });
                });

        }
        function mergeData(priorityList, statusList) {

            // Normalize inputs to arrays and add fallbacks for missing names/keys
            var pList = Array.isArray(priorityList) ? priorityList : (priorityList ? [priorityList] : []);
            var sList = Array.isArray(statusList) ? statusList : (statusList ? [statusList] : []);
            // console.log('Merging data - Priority List:', sList);

            vm.finalData = [];
            var statusMap = {};
            for (var i = 0; i < sList.length; i++) {
                var statusItem = sList[i] || {};
                var statusName = statusItem.geofenceName || statusItem.districtName || statusItem.name || 'TOTAL';
                statusMap[statusName] = statusItem;
            }
            for (var j = 0; j < pList.length; j++) {
                var p = pList[j] || {};
                var name = p.geofenceName || p.districtName || p.name || 'TOTAL';
                var s = statusMap[name] || { caseType: {} };

                vm.finalData.push({
                    geofenceName: name,
                    casePriority: p.casePriority || p.casepriority || {},
                    caseType: s.caseType || s.casetype || {}
                });
            }

            vm.geofenceData = vm.finalData;
            vm.incidentData = vm.finalData;
        }

        vm.ngRepeatDone = function () {
            $timeout(renderAllBusinessAreaCharts, 0); // DOM ready
        };
        function calculateTotals() {

            var totals = {
                CRITICAL: 0,
                HIGH: 0,
                MEDIUM: 0,
                LOW: 0,
                ASSIGNED: 0,
                TOBEASSIGNED: 0,
                RESOLVED: 0,
                // NEW: 0,
                // CANCELLED: 0,
                CLOSED: 0,
                INPROGRESS: 0,
                PENDING: 0
            };

            for (var i = 0; i < vm.finalData.length; i++) {

                var p = vm.finalData[i].casePriority || {};
                var t = vm.finalData[i].caseType || {};

                totals.CRITICAL += p.CRITICAL || 0;
                totals.HIGH += p.HIGH || 0;
                totals.MEDIUM += p.MEDIUM || 0;
                totals.LOW += p.LOW || 0;

                // totals.NEW += t.NEW || 0;
                totals.ASSIGNED += t.ASSIGNED || 0;
                totals.TOBEASSIGNED += t.TOBEASSIGNED || 0;
                totals.RESOLVED += t.RESOLVED || 0;
                // totals.CANCELLED += t.CANCELLED || 0;
                totals.CLOSED += t.CLOSED || 0;
                totals.INPROGRESS += t.INPROGRESS || 0;
                totals.PENDING += t.PENDING || 0;
            }

            vm.priorityTotals = totals;

            // Recalculate SLA compliance now that we have real priorityTotals data
            recalculateSLACompliance();

            // refresh the overall distribution pie whenever totals change
            $timeout(renderOverallDistributionChart, 0);
            $timeout(renderOverallStatusChart, 0);
        }

        function prepareBusinessAreaCases() {
            vm.businessAreaCases = [];

            for (var i = 0; i < vm.geofenceData.length; i++) {
                var item = vm.geofenceData[i];
                var p = item.casePriority || {};

                vm.businessAreaCases.push({
                    areaName: item.geofenceName,
                    critical: p.CRITICAL || 0,
                    high: p.HIGH || 0,
                    medium: p.MEDIUM || 0,
                    low: p.LOW || 0
                });
            }
        }

        function renderDonutAreaCharts() {

            d3.selectAll(".ba-chart-svg").remove();   // clear old SVGs

            var colors = {
                Critical: "#ff5c5c",
                High: "#ffa533",
                Medium: "#00e658",
                Low: "#294985"
            };

            var statusKeys = ["Critical", "High", "Medium", "Low"];

            // Tooltip (same as sync chart)
            var tooltip = d3.select("body").append("div")
                .attr("class", "chart-tooltip")
                .style("position", "absolute")
                .style("background", "white")
                .style("border", "1px solid #ccc")
                .style("padding", "6px 8px")
                .style("font-size", "12px")
                .style("border-radius", "4px")
                .style("pointer-events", "none")
                .style("opacity", 0);

            for (var i = 0; i < vm.businessAreaCases.length; i++) {

                var area = vm.businessAreaCases[i];
                var chartId = "donut-chart-" + i;

                var container = document.getElementById(chartId);
                if (!container) continue;

                var width = 220,
                    height = 180,
                    margin = { top: 20, right: 10, bottom: 60, left: 40 };

                var svg = d3.select("#" + chartId)
                    .append("svg")
                    .attr("class", "ba-chart-svg")
                    .attr("width", width)
                    .attr("height", height);

                var chartWidth = width - margin.left - margin.right;
                var chartHeight = height - margin.top - margin.bottom;

                var g = svg.append("g")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

                // Values
                var values = [
                    { key: "Critical", value: area.critical },
                    { key: "High", value: area.high },
                    { key: "Medium", value: area.medium },
                    { key: "Low", value: area.low }
                ];

                // Scales
                var x = d3.scale.ordinal()
                    .domain(statusKeys)
                    .rangeBands([0, chartWidth], 0.3);

                var y = d3.scale.linear()
                    .domain([0, d3.max(values, function (d) { return d.value; }) || 1])
                    .range([chartHeight, 0]);

                // Y-Axis (same style as sync chart)
                var yAxis = d3.svg.axis().scale(y).orient("left").ticks(5);
                g.append("g").attr("class", "y axis").call(yAxis);

                function make_y_grid() {
                    return d3.svg.axis()
                        .scale(y)
                        .orient("left")
                        .ticks(5);
                }

                g.append("g")
                    .attr("class", "grids horizontal-grid")
                    .call(make_y_grid()
                        .tickSize(-width, 0, 0)
                        .tickFormat("")
                    );
                function make_x_grid() {
                    return d3.svg.axis()
                        .scale(x)
                        .orient("bottom")
                        .ticks(vm.businessAreaCases.length);
                }

                g.append("g")
                    .attr("class", "grids vertical-grid")
                    .attr("transform", "translate(0," + chartHeight + ")")
                    .call(make_x_grid()
                        .tickSize(-chartHeight, 0, 0)
                        .tickFormat("")
                    );

                // Bars
                g.selectAll("rect")
                    .data(values)
                    .enter()
                    .append("rect")
                    .attr("x", function (d) { return x(d.key); })
                    .attr("y", function (d) { return y(d.value); })
                    .attr("width", x.rangeBand())
                    .attr("height", function (d) { return chartHeight - y(d.value); })
                    .style("fill", function (d) { return colors[d.key]; })
                    .on("mouseover", function (d) {
                        tooltip.transition().duration(200).style("opacity", 0.9);
                        tooltip.html("<b>" + d.key + "</b>: " + d.value);
                    })
                    .on("mousemove", function () {
                        tooltip.style("left", (d3.event.pageX + 10) + "px")
                            .style("top", (d3.event.pageY - 28) + "px");
                    })
                    .on("mouseout", function () {
                        tooltip.transition().duration(500).style("opacity", 0);
                    });

                // Value labels
                g.selectAll(".bar-value")
                    .data(values)
                    .enter()
                    .append("text")
                    .attr("class", "bar-value")
                    .attr("x", function (d) { return x(d.key) + x.rangeBand() / 2; })
                    .attr("y", function (d) { return y(d.value) - 5; })
                    .attr("text-anchor", "middle")
                    .style("font-size", "12px")
                    .style("font-weight", "bold")
                    .text(function (d) { return d.value; });

                // X-Axis labels
                var xAxis = d3.svg.axis().scale(x).orient("bottom");
                g.append("g")
                    .attr("class", "x axis")
                    .attr("transform", "translate(0," + chartHeight + ")")
                    .call(xAxis)
                    .selectAll("text")
                    .style("font-size", "10px")
                    .style("text-anchor", "end")
                    .attr("dx", "-0.5em")
                    .attr("dy", "0.2em")
                    .attr("transform", "rotate(-25)");

            }
        }

        function renderBarAreaCharts() {
            // remove any existing svg and tooltip for bar charts
            d3.selectAll(".ba-bar-svg").remove();
            d3.selectAll(".chart-tooltip").remove();

            var colors = {
                Met: "#1abc9c",
                Breached: "#cc0033"
            };

            // Tooltip
            var tooltip = d3.select("body").append("div")
                .attr("class", "chart-tooltip")
                .style("position", "absolute")
                .style("background", "white")
                .style("border", "1px solid #ccc")
                .style("padding", "6px 8px")
                .style("font-size", "12px")
                .style("border-radius", "4px")
                .style("pointer-events", "none")
                .style("opacity", 0);

            for (var i = 0; i < vm.businessAreaCases.length; i++) {
                var area = vm.businessAreaCases[i];
                var chartId = "bar-chart-" + i;
                var container = document.getElementById(chartId);
                if (!container) continue;

                var width = 220,
                    height = 180,
                    margin = { top: 20, right: 10, bottom: 60, left: 40 };

                var svg = d3.select("#" + chartId)
                    .append("svg")
                    .attr("class", "ba-bar-svg")
                    .attr("width", width)
                    .attr("height", height);

                var chartWidth = width - margin.left - margin.right;
                var chartHeight = height - margin.top - margin.bottom;

                var g = svg.append("g")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

                // Derive simple SLA values from area counts (used as dummy values)
                var slaMet = (area.medium || 0) + (area.low || 0) + Math.floor((area.high || 0) / 2);
                var slaBreached = (area.critical || 0) + Math.ceil((area.high || 0) / 2);

                // Ensure dummy values are visible — if computed SLA Breached is zero, set a default
                if (!slaMet || slaMet === 0) {
                    slaMet = 5;
                }
                if (!slaBreached || slaBreached === 0) {
                    slaBreached = 3;
                }

                var values = [
                    { key: "SLA Met", value: slaMet },
                    { key: "SLA Breached", value: slaBreached }
                ];

                var x = d3.scale.ordinal()
                    .domain(values.map(function (d) { return d.key; }))
                    .rangeBands([0, chartWidth], 0.6);

                var y = d3.scale.linear()
                    .domain([0, d3.max(values, function (d) { return d.value; }) || 1])
                    .range([chartHeight, 0]);

                var yAxis = d3.svg.axis().scale(y).orient("left").ticks(5);
                g.append("g").attr("class", "y axis").call(yAxis);

                // Grid lines (horizontal)
                function make_y_grid() {
                    return d3.svg.axis()
                        .scale(y)
                        .orient("left")
                        .ticks(5);
                }

                g.append("g")
                    .attr("class", "grids horizontal-grid")
                    .call(make_y_grid()
                        .tickSize(-width, 0, 0)
                        .tickFormat("")
                    );

                // Grid lines (vertical)
                function make_x_grid() {
                    return d3.svg.axis()
                        .scale(x)
                        .orient("bottom")
                        .ticks(values.length);
                }

                g.append("g")
                    .attr("class", "grids vertical-grid")
                    .attr("transform", "translate(0," + chartHeight + ")")
                    .call(make_x_grid()
                        .tickSize(-chartHeight, 0, 0)
                        .tickFormat("")
                    );

                // Bars
                g.selectAll("rect")
                    .data(values)
                    .enter()
                    .append("rect")
                    .attr("x", function (d) { return x(d.key); })
                    .attr("y", function (d) { return y(d.value); })
                    .attr("width", x.rangeBand())
                    .attr("height", function (d) { return chartHeight - y(d.value); })
                    .style("fill", function (d) { return d.key === 'SLA Met' ? colors.Met : colors.Breached; })
                    .on("mouseover", function (d) {
                        tooltip.transition().duration(200).style("opacity", 0.9);
                        tooltip.html("<b>" + d.key + "</b>: " + d.value);
                    })
                    .on("mousemove", function () {
                        tooltip.style("left", (d3.event.pageX + 10) + "px")
                            .style("top", (d3.event.pageY - 28) + "px");
                    })
                    .on("mouseout", function () {
                        tooltip.transition().duration(500).style("opacity", 0);
                    });

                // Value labels
                g.selectAll(".bar-value")
                    .data(values)
                    .enter()
                    .append("text")
                    .attr("class", "bar-value")
                    .attr("x", function (d) { return x(d.key) + x.rangeBand() / 2; })
                    .attr("y", function (d) { return y(d.value) - 5; })
                    .attr("text-anchor", "middle")
                    .style("font-size", "12px")
                    .style("font-weight", "bold")
                    .text(function (d) { return d.value; });

                // X-Axis labels
                var xAxis = d3.svg.axis().scale(x).orient("bottom");
                g.append("g")
                    .attr("class", "x axis")
                    .attr("transform", "translate(0," + chartHeight + ")")
                    .call(xAxis)
                    .selectAll("text")
                    .style("font-size", "10px")
                    .style("text-anchor", "end")
                    .attr("dx", "-0.5em")
                    .attr("dy", "0.2em")
                    .attr("transform", "rotate(-25)");

                
            }
        }

        // Render Overall Observation Line Chart (Weekly KPI) using Highcharts
        function renderOverallObservationChart() {
            var chartElement = document.getElementById('overall-observation-chart');
            if (!chartElement) return;

            // Prepare data from API response or use defaults
            var categories = [];
            var activeIncidents = [];
            var nearThreshold = [];
            var slaMetWithinTime = [];
            var slaMetAfterTime = [];
            var slaBreached = [];
            var slaExclusion = [];
            
            // console.log('renderOverallObservationChart called - vm.dayWiseTrendData:', vm.dayWiseTrendData);
            
            if (vm.dayWiseTrendData && typeof vm.dayWiseTrendData === 'object' && Object.keys(vm.dayWiseTrendData).length > 0) {
                // console.log('Processing API data - keys count:', Object.keys(vm.dayWiseTrendData).length);
                // console.log('Sample dayData structure:', vm.dayWiseTrendData[Object.keys(vm.dayWiseTrendData)[0]]);
                // API returns object with date keys - need to sort and transform
                var dateKeys = Object.keys(vm.dayWiseTrendData).sort(function(a, b) {
                    return new Date(a) - new Date(b);
                });
                
                dateKeys.forEach(function(dateKey) {
                    var dayData = vm.dayWiseTrendData[dateKey];
                    
                    // Format date to show month-day (e.g., "Jan 05")
                    var date = new Date(dateKey);
                    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    var formattedDate = months[date.getMonth()] + ' ' + date.getDate();
                    
                    categories.push(formattedDate);
                    activeIncidents.push(dayData.activeCaseCount || 0);
                    nearThreshold.push(dayData.nearBreachCount || 0);
                    slaMetWithinTime.push(dayData.resolvedWithinTime || 0);
                    slaMetAfterTime.push(dayData.resolvedAfterTime || 0);
                    slaBreached.push(dayData.breachedCount || 0);
                    slaExclusion.push(dayData.pendingCount || 0);
                });
            } else {
                console.warn('No API data found, using empty arrays');
                // Don't use dummy data - show empty chart or minimal data
                categories = ['No Data'];
                activeIncidents = [0];
                nearThreshold = [0];
                slaMetWithinTime = [0];
                slaMetAfterTime = [0];
                slaBreached = [0];
                slaExclusion = [0];
            }

            Highcharts.chart('overall-observation-chart', {
                chart: {
                    type: 'line',
                    height: 280,
                    style: { fontFamily: 'Segoe UI, Arial' },
                    spacingTop: 10,
                    spacingRight: 10,
                    spacingBottom: 10,
                    spacingLeft: 10,
                    zoomType: 'xy',
                    panning: {
                        enabled: true,
                        type: 'xy'
                    }
                },
                exporting: { enabled: false },
                title: null,
                xAxis: {
                    categories: categories,
                    crosshair: true
                },
                yAxis: {
                    title: { text: null }
                },
                tooltip: {
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y}</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    line: {
                        dataLabels: { enabled: false },
                        enableMouseTracking: true,
                        lineWidth: 2.5,
                        states: {
                            hover: {
                                lineWidth: 3
                            }
                        }
                    },
                    column: {
                        stacking: 'normal',
                        dataLabels: { enabled: false },
                        enableMouseTracking: true
                    }
                },
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom',
                    itemStyle: { fontWeight: 'normal' }
                },
                series: [
                    {
                        name: 'Active Incidents',
                        data: activeIncidents,
                        color: '#2980b9',
                        type: 'spline'
                    },
                    {
                        name: 'Near Threshold',
                        data: nearThreshold,
                        color: '#f4d03f',
                        type: 'column'
                    },
                    {
                        name: 'Resolved (Within SLA Time)',
                        data: slaMetWithinTime,
                        color: '#1abc9c',
                        type: 'column',
                        stack: 'slaMet'
                    },
                    {
                        name: 'Resolved (After SLA Time)',
                        data: slaMetAfterTime,
                        color: '#e67e22',
                        type: 'column',
                        stack: 'slaMet'
                    },
                    {
                        name: 'SLA Breached',
                        data: slaBreached,
                        color: '#cc0033',
                        type: 'column'
                    },
                    {
                        name: 'SLA Exclusion',
                        data: slaExclusion,
                        color: '#95a5a6',
                        type: 'column'
                    }
                ],
                credits: { enabled: false }
            });
        }

        // Render Overall Distribution Pie Chart using Highcharts
        function renderOverallDistributionChart() {
            var chartElement = document.getElementById('overall-distribution-chart');
            if (!chartElement) return;

            var totals = vm.priorityTotals || {};

            // inner ring: status distribution
            var statusTotal = (totals.ASSIGNED || 0) + (totals.TOBEASSIGNED || 0) + (totals.RESOLVED || 0)   + (totals.CLOSED || 0) + (totals.INPROGRESS || 0) + (totals.PENDING || 0);
            var statusSeries = statusTotal === 0 ? [
                { name: 'Assigned', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'To Be Assigned', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'Resolved', y: 1, displayValue: 0, color: '#d3d3d3' },
                // { name: 'New', y: 1, displayValue: 0, color: '#d3d3d3' },
                // { name: 'Cancelled', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'Closed', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'In Progress', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'Out of Scope', y: 1, displayValue: 0, color: '#d3d3d3' }
            ] : [
                { name: 'Assigned',      y: totals.ASSIGNED || 0,      displayValue: totals.ASSIGNED || 0,      color: '#2980b9' },
                { name: 'To Be Assigned',y: totals.TOBEASSIGNED || 0,   displayValue: totals.TOBEASSIGNED || 0,   color: '#7a4fff' },
                { name: 'Resolved',      y: totals.RESOLVED || 0,      displayValue: totals.RESOLVED || 0,      color: '#1abc9c' },
                // { name: 'New',           y: totals.NEW || 0,           displayValue: totals.NEW || 0,           color: '#f39c12' },
                // { name: 'Cancelled',     y: totals.CANCELLED || 0,     displayValue: totals.CANCELLED || 0,     color: '#95a5a6' },
                { name: 'Closed',        y: totals.CLOSED || 0,        displayValue: totals.CLOSED || 0,        color: '#34495e' },
                { name: 'In Progress',   y: totals.INPROGRESS || 0,    displayValue: totals.INPROGRESS || 0,    color: '#9b59b6' },
                { name: 'Out of Scope',       y: totals.PENDING || 0,       displayValue: totals.PENDING || 0,       color: '#e67e22' }
            ];

            // outer ring: priority distribution
            var priorityCount = (totals.CRITICAL || 0) + (totals.HIGH || 0) + (totals.MEDIUM || 0) + (totals.LOW || 0);
            var prioritySeries = priorityCount === 0 ? [
                { name: 'Critical', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'High',     y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'Medium',   y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'Low',      y: 1, displayValue: 0, color: '#d3d3d3' }
            ] : [
                { name: 'Critical', y: totals.CRITICAL || 0, displayValue: totals.CRITICAL || 0, color: '#ff5c5c' },
                { name: 'High',     y: totals.HIGH || 0,     displayValue: totals.HIGH || 0,     color: '#ffa533' },
                { name: 'Medium',   y: totals.MEDIUM || 0,   displayValue: totals.MEDIUM || 0,   color: '#00e658' },
                { name: 'Low',      y: totals.LOW || 0,      displayValue: totals.LOW || 0,      color: '#294985' }
            ];

            Highcharts.chart('overall-distribution-chart', {
                chart: {
                    type: 'pie',
                    height: 280,
                    style: { fontFamily: 'Segoe UI, Arial' },
                    spacingRight: 160,
                    events: {
                        load: function() {
                            var chart = this;
                            var legend = chart.legend;
                            
                            // Create custom legend HTML with table format
                            var legendHTML = '<table style="font-size:10px; width:100%;">';
                            
                            // Status header and items
                            legendHTML += '<tr><td colspan="2" style="font-weight:bold; font-size:11px; padding-top:5px; padding-bottom:5px; color:#333;">Status</td></tr>';
                            statusSeries.forEach(function(item, index) {
                                legendHTML += '<tr class="legend-item" data-series="0" data-index="' + index + '" style="cursor:pointer;">' +
                                    '<td style="padding:2px 5px 2px 0;"><span style="display:inline-block; width:10px; height:10px; background-color:' + item.color + '; border-radius:2px; margin-right:5px;"></span><span class="legend-text">' + item.name + '</span></td>' +
                                    '<td style="padding:2px 0; text-align:right;" class="legend-value"><b>' + item.displayValue + '</b></td>' +
                                    '</tr>';
                            });
                            
                            // Priority header and items
                            legendHTML += '<tr><td colspan="2" style="font-weight:bold; font-size:11px; padding-top:10px; padding-bottom:5px; color:#333;">Priority</td></tr>';
                            prioritySeries.forEach(function(item, index) {
                                legendHTML += '<tr class="legend-item" data-series="1" data-index="' + index + '" style="cursor:pointer;">' +
                                    '<td style="padding:2px 5px 2px 0;"><span style="display:inline-block; width:10px; height:10px; background-color:' + item.color + '; border-radius:2px; margin-right:5px;"></span><span class="legend-text">' + item.name + '</span></td>' +
                                    '<td style="padding:2px 0; text-align:right;" class="legend-value"><b>' + item.displayValue + '</b></td>' +
                                    '</tr>';
                            });
                            
                            legendHTML += '</table>';
                            
                            // Add custom legend to the chart - positioned on the right side
                            var legendWidth = 150;
                            var xPos = chart.chartWidth - legendWidth - 5;
                            var yPos = 30;
                            
                            var legendElement = chart.renderer.html(legendHTML, xPos, yPos)
                                .attr({ 
                                    zIndex: 5
                                })
                                .css({
                                    width: legendWidth + 'px'
                                })
                                .add();
                            
                            // Add click handlers to legend items
                            $timeout(function() {
                                var legendItems = document.querySelectorAll('#overall-distribution-chart .legend-item');
                                legendItems.forEach(function(item) {
                                    item.addEventListener('click', function() {
                                        var seriesIndex = parseInt(this.getAttribute('data-series'));
                                        var pointIndex = parseInt(this.getAttribute('data-index'));
                                        var series = chart.series[seriesIndex];
                                        var point = series.data[pointIndex];
                                        
                                        if (point.visible) {
                                            point.setVisible(false);
                                            this.style.opacity = '0.3';
                                            this.querySelector('.legend-text').style.textDecoration = 'line-through';
                                        } else {
                                            point.setVisible(true);
                                            this.style.opacity = '1';
                                            this.querySelector('.legend-text').style.textDecoration = 'none';
                                        }
                                    });
                                });
                            }, 100);
                        }
                    }
                },
                exporting: { enabled: false },
                title: null,
                tooltip: {
                    pointFormat: '<span style="color:{point.color}">●</span> <b>{point.name}</b>: {point.displayValue} <br/>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        cursor: 'pointer',
                        dataLabels: { enabled: false },
                        showInLegend: false
                    }
                },
                legend: {
                    enabled: false
                },
                series: [
                    {
                        name: 'Status',
                        colorByPoint: true,
                        innerSize: '55%',
                        data: statusSeries,
                        showInLegend: false,
                        dataLabels: { enabled: false }
                    },
                    {
                        name: 'Priority',
                        colorByPoint: true,
                        size: '80%',
                        innerSize: '65%',
                        data: prioritySeries,
                        showInLegend: false,
                        dataLabels: { enabled: false }
                    }
                ],
                credits: { enabled: false }
            });
        }

        // Render Overall Status Pie Chart using Highcharts
        function renderOverallStatusChart() {
            var chartElement = document.getElementById('overall-status-chart');
            if (!chartElement) return;

            var totals = vm.priorityTotals || {};
            var totalCount = (totals.ASSIGNED || 0) + (totals.TOBEASSIGNED || 0) + (totals.RESOLVED || 0) + (totals.NEW || 0) + (totals.CANCELLED || 0) + (totals.CLOSED || 0) + (totals.INPROGRESS || 0) + (totals.PENDING || 0);

            // Recalculate SLA compliance now that priorityTotals is updated with real data
            recalculateSLACompliance();

            var dataPoints;
            if (totalCount === 0) {
                dataPoints = [
                    { name: 'Assigned', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'To Be Assigned', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'Resolved', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'New', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'Cancelled', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'Closed', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'In Progress', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'Pending', y: 1, displayValue: 0, color: '#d3d3d3' }
                ];
            } else {
                dataPoints = [
                    { name: 'Assigned',      y: totals.ASSIGNED || 0,      displayValue: totals.ASSIGNED || 0,      color: '#2980b9' },
                    { name: 'To Be Assigned',y: totals.TOBEASSIGNED || 0,   displayValue: totals.TOBEASSIGNED || 0,   color: '#7a4fff' },
                    { name: 'Resolved',      y: totals.RESOLVED || 0,      displayValue: totals.RESOLVED || 0,      color: '#1abc9c' },
                    { name: 'New',           y: totals.NEW || 0,           displayValue: totals.NEW || 0,           color: '#f39c12' },
                    { name: 'Cancelled',     y: totals.CANCELLED || 0,     displayValue: totals.CANCELLED || 0,     color: '#95a5a6' },
                    { name: 'Closed',        y: totals.CLOSED || 0,        displayValue: totals.CLOSED || 0,        color: '#34495e' },
                    { name: 'In Progress',   y: totals.INPROGRESS || 0,    displayValue: totals.INPROGRESS || 0,    color: '#9b59b6' },
                    { name: 'Pending',       y: totals.PENDING || 0,       displayValue: totals.PENDING || 0,       color: '#e67e22' }
                ];
            }

            Highcharts.chart('overall-status-chart', {
                chart: {
                    type: 'pie',
                    height: 260,
                    style: { fontFamily: 'Segoe UI, Arial' }
                },
                exporting: { enabled: false },
                title: null,
                tooltip: {
                    pointFormat: '<span style="color:{point.color}">●</span> <b>{point.name}</b>: {point.displayValue}<br/>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        cursor: 'pointer',
                        innerSize: '50%',
                        dataLabels: { enabled: false },
                        showInLegend: true
                    }
                },
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom',
                    itemStyle: { fontWeight: 'normal' },
                    useHTML: true,
                    labelFormatter: function() {
                        return this.name + ': <b>' + this.displayValue + '</b>';
                    }
                },
                series: [{
                    name: 'Status',
                    colorByPoint: true,
                    data: dataPoints
                }],
                credits: { enabled: false }
            });
        }

        // Render Response Time vs Resolution Time Chart
        function renderResponseTimeChart() {
            var chartElement = document.getElementById('response-time-chart');
            if (!chartElement) return;

            Highcharts.chart('response-time-chart', {
                chart: {
                    type: 'bar',
                    height: 200,
                    style: { fontFamily: 'Segoe UI, Arial' },
                    zoomType: 'xy',
                    panning: {
                        enabled: true,
                        type: 'xy'
                    }
                },
                exporting: { enabled: false },
                title: null,
                xAxis: {
                    categories: [''],
                    labels: {
                        enabled: false
                    }
                },
                yAxis: {
                    title: { text: 'Hours' },
                    min: 0,
                    max: 12,
                    plotLines: [{
                        value: 8,
                        color: '#cc0033',
                        width: 2,
                        dashStyle: 'Dash',
                        label: {
                            text: 'Threshold (8 hrs)',
                            align: 'right',
                            style: {
                                color: '#cc0033',
                                fontWeight: 'bold'
                            }
                        },
                        zIndex: 5
                    }]
                },
                tooltip: {
                    useHTML: true,
                    style: {
                        whiteSpace: 'normal'
                    },
                    formatter: function() {
                        return '<b>' + this.series.name + '</b><br/>' + this.y + ' hrs';
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: { 
                            enabled: true,
                            format: '{point.y} hrs',
                            style: { fontSize: '12px', fontWeight: 'bold' }
                        },
                        groupPadding: 0.1,
                        pointPadding: 0.1
                    },
                    series: {
                        pointWidth: 35
                    }
                },
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom',
                    itemStyle: { fontWeight: 'normal' }
                },
                series: [
                    {
                        name: 'Avg Response Time',
                        data: [vm.avgResponseHours || 0],
                        color: '#e84393'
                    },
                    {
                        name: 'Avg Resolution Time',
                        data: [vm.avgResolutionHours || 0],
                        color: '#34495e'
                    }
                ],
                credits: { enabled: false }
            });
        }

        // Initialize charts on load
        $timeout(function() {
            renderOverallDistributionChart();
            renderOverallStatusChart();
            // renderOverallObservationChart(); // Don't render initially - will be rendered when API data loads
            renderResponseTimeChart();
        }, 500);

        // render both kinds of charts (donut placeholders and bar charts)
        function renderAllBusinessAreaCharts() {
            try {
                renderDonutAreaCharts();
            } catch (e) {
                // swallow errors so other charts still attempt to render
                console.error('Error rendering donut area charts', e);
            }
            try {
                renderBarAreaCharts();
            } catch (e) {
                console.error('Error rendering bar area charts', e);
            }
        }
    }
})();